/* dg-duo-sections-v304.js: the Deco Gear 34" 180Hz Monitor (DGVIEW304) copy of dg-duo-sections-l340.js (the live 34" Business page B, never
   touched). Same page rhythm and the same 34" housing: every picture is the live 34" render set (dgr-dglux340-*, same body) with its screen maps
   dgr-dglux340-screen-maps.json, and the 3D is the live 34" swoosh, all unchanged. Numbers from deco-profit-monitor/data/facts/DGVIEW304.md only:
   180 Hz over DisplayPort (18 frames against 6 in 100 ms), 3000:1, 31.9 in wide, VESA 100 x 100. No USB-C, no USB hub, no DCI-P3 figure.
   Header of dg-duo-sections-l340.js follows.
   dg-duo-sections-l340.js: the 34" Business Monitor (DGLUX340) copy of dg-duo-sections-v401.js. Every picture is a 34" render (dgr-dglux340-*),
   the screen maps are dgr-dglux340-screen-maps.json (measured from those renders' pixels), and the screen content is drawn at the panel's
   43:18 (3440 x 1440) shape. */
window.DGWI=(function(){
  var BASE=window.DGX_BASE+'dgr-dglux340-', W={front:[960,1600,2364],'front-34':[960,1600],rear:[960,1600],'rear-34':[960,1600]};
  return {base:BASE,maps:window.DGX_BASE+'dgr-dglux340-screen-maps.json',
    src:function(slug,devW){var ws=W[slug],k;for(k=0;k<ws.length;k++)if(ws[k]>=devW)return BASE+slug+'-'+ws[k]+'.webp';return BASE+slug+'-'+ws[ws.length-1]+'.webp'}};
})();
/* DGRibbonsL340: the one colour-ribbon look used on every screen of the page. Same maths and colours as the hero colour() and the
   other pages' DGRibbons (navy field, five luminous sine ribbons, blurred 7px with additive blending, then scaled up smoothly),
   on a 387x162 field (43:18, this panel's 3440 x 1440 shape) instead of 384x108 (32:9), with the vertical amplitudes scaled by the same 1.5
   so the ribbons fill the taller screen at the same on-screen thickness. Kept under its own name so that it never changes the
   ribbons the hero or the live test use.
   draw(ctx, w, h, t, opts)  t = seconds; opts = {x, y, logo:Image, logoAt:0.35, phase:0} */
(function () {
  if (window.DGRibbonsL340) return;
  var FW = 387, FH = 162, VS = 1.5, RIB = [[255, 64, 129], [255, 149, 0], [0, 199, 255], [124, 77, 255], [0, 230, 160]];
  var fld = null, fx = null, sm = null, smx = null, HASF = true;
  function init() {
    fld = document.createElement('canvas'); fld.width = FW; fld.height = FH; fx = fld.getContext('2d');
    HASF = typeof fx.filter === 'string';
    if (!HASF) { sm = document.createElement('canvas'); sm.width = FW / 4; sm.height = FH / 4; smx = sm.getContext('2d'); }
  }
  function field(t) {
    fx.globalCompositeOperation = 'source-over'; fx.filter = 'none';
    fx.fillStyle = '#07081a'; fx.fillRect(0, 0, FW, FH);
    fx.globalCompositeOperation = 'lighter';
    for (var k = 0; k < RIB.length; k++) {
      var c = RIB[k], ph = t * .35 + k * 1.3; fx.beginPath();
      for (var i = 0; i <= 48; i++) { var X = i / 48 * FW, Y = FH / 2 + Math.sin(i / 48 * Math.PI * 2 * (.8 + k * .15) + ph) * 26 * VS + Math.sin(i / 9 + ph * 1.7) * 7 * VS; i ? fx.lineTo(X, Y) : fx.moveTo(X, Y); }
      fx.lineWidth = (18 + 8 * Math.sin(ph * .7)) * 1.25;
      var g = fx.createLinearGradient(0, 0, FW, 0); g.addColorStop(0, 'rgba(' + c + ',0)'); g.addColorStop(.5, 'rgba(' + c + ',.85)'); g.addColorStop(1, 'rgba(' + c + ',.15)');
      fx.strokeStyle = g; if (HASF) fx.filter = 'blur(7px)'; fx.stroke();
    }
    fx.filter = 'none'; fx.globalCompositeOperation = 'source-over';
    if (!HASF) { // no canvas filter (older Safari): soften by a quarter-size resample instead
      smx.clearRect(0, 0, sm.width, sm.height); smx.imageSmoothingEnabled = true; smx.drawImage(fld, 0, 0, sm.width, sm.height);
      fx.imageSmoothingEnabled = true; fx.drawImage(sm, 0, 0, FW, FH);
    }
  }
  function draw(x, w, h, t, opts) {
    opts = opts || {}; if (!fld) init();
    var ox = opts.x || 0, oy = opts.y || 0;
    field((t || 0) + (opts.phase || 0));
    x.save();
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high'; x.drawImage(fld, ox, oy, w, h);
    var L = opts.logo, at = opts.logoAt == null ? .35 : opts.logoAt;
    var a = Math.min(1, Math.max(0, ((t || 0) - at) / .6));
    if (L && L.complete && L.naturalWidth && a > 0) {
      var lw = w * .34, lh = lw * 41.81 / 319.26, s = .96 + .04 * a;
      x.globalAlpha = a; x.translate(ox + w / 2, oy + h / 2); x.scale(s, s);
      x.shadowColor = 'rgba(0,0,0,.35)'; x.shadowBlur = 24; x.drawImage(L, -lw / 2, -lh / 2, lw, lh);
    }
    x.restore();
  }
  window.DGRibbonsL340 = { draw: draw, colours: RIB };
})();

/* highlights: Apple-style media gallery. Six cards, each a live canvas animation on the real factory render
   (screen content painted through screen-maps.json). The active card plays once; autoplay advances.
   The cards: two 1720 x 1440 halves, the 1500R curve, 180 Hz, 3000:1 contrast, four video inputs, picture-by-picture. */
(function () {
  var root = document.getElementById('dg-highlights'); if (!root) return;
  var M = Math, RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scroller = root.querySelector('.hl-scroller'), cards = [].slice.call(root.querySelectorAll('.hl-card'));
  var dotsEl = root.querySelector('.hl-dots'), playBtn = root.querySelector('.hl-play');
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function seg(t, a, b) { return clamp((t - a) / (b - a), 0, 1); }
  function eio(t) { return t < .5 ? 4 * t * t * t : 1 - M.pow(-2 * t + 2, 3) / 2; }
  function eo(t) { return 1 - M.pow(1 - t, 3); }
  function es(t, a, b) { return eio(seg(t, a, b)); }
  function mk(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  function rr(c, x, y, w, h, r) { c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath(); }
  var MAPS = null, IM = {}, dpr = M.min(2, window.devicePixelRatio || 1);
  function img(key, src) { if (IM[key]) return IM[key]; var i = new Image(); i.decoding = 'async'; i.src = src; i.onload = function () { dirty = true; }; IM[key] = i; return i; }
  function ok(i) { return i && i.complete && i.naturalWidth > 0; }
  function pick(slug, devW) { return DGWI.src(slug, devW); }

  /* ---------- screen content: a logical 1290 x 540 (43:18, the 3440 x 1440 panel's shape) canvas ---------- */
  var CW = 1290, CH = 540, SC = mk(CW, CH), sx = SC.getContext('2d');
  // colour ribbons: the page's one shared look (sections/ribbons.js, same maths as the hero)
  function ribbons(c, x, y, w, h, t, phase) { window.DGRibbonsL340.draw(c, w, h, t, { x: x, y: y, phase: phase || 0 }); }
  /* "Two monitors. No seam." screen content: real-looking app windows, drawn at 2x for crisp text.
     Same compositing as the Work card (versatility.js): window chrome, a document, a spreadsheet, menu bars. */
  var SS = mk(CW * 2, CH * 2), ss = SS.getContext('2d');
  var UIF = '-apple-system,BlinkMacSystemFont,"SF Pro Text","Inter","Helvetica Neue",sans-serif';
  var COAST = img('coast', (window.DGX&&DGX["dgx-duo-coast-l340.jpg"])||'dgx-duo-coast-l340.jpg');
  function rnd(seed) { var s = seed; return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
  function winChrome(c, x, y, w, h, title) {
    c.save(); c.shadowColor = 'rgba(0,0,0,.5)'; c.shadowBlur = 30; c.shadowOffsetY = 8;
    rr(c, x, y, w, h, 7); c.fillStyle = '#fff'; c.fill(); c.restore();
    c.save(); rr(c, x, y, w, h, 7); c.clip(); c.fillStyle = '#ececee'; c.fillRect(x, y, w, 17); c.fillStyle = 'rgba(0,0,0,.1)'; c.fillRect(x, y + 17, w, .6);
    ['#ff5f57', '#febc2e', '#28c840'].forEach(function (col, i) { c.beginPath(); c.arc(x + 10 + i * 9.5, y + 8.5, 3.1, 0, 7); c.fillStyle = col; c.fill(); });
    c.fillStyle = '#3a3a3c'; c.font = '600 7.5px ' + UIF; c.textAlign = 'center'; c.fillText(title, x + w / 2, y + 11.4); c.textAlign = 'left'; c.restore();
  }
  function textLines(c, x, y, w, n, r, gap) { for (var i = 0; i < n; i++) { var lw = (i % 6 === 5) ? w * (.3 + r() * .3) : w * (.82 + r() * .18); c.fillRect(x, y + i * (gap || 7.5), lw, 3); } }
  function menubar(c, x, w, app, active) {
    c.fillStyle = active ? 'rgba(18,18,30,.55)' : 'rgba(18,18,30,.35)'; c.fillRect(x, 0, w, 12);
    c.fillStyle = active ? 'rgba(255,255,255,.95)' : 'rgba(255,255,255,.55)'; c.font = '700 7px ' + UIF; c.textAlign = 'left'; c.fillText(app, x + 10, 8.6);
    var mx = x + 22 + c.measureText(app).width; c.font = '7px ' + UIF;
    ['File', 'Edit', 'View', 'Insert', 'Format', 'Window', 'Help'].forEach(function (s) { c.fillText(s, mx, 8.6); mx += c.measureText(s).width + 11; });
    c.textAlign = 'right'; c.fillText('Fri 9:41', x + w - 10, 8.6);
    c.fillRect(x + w - 52, 4, 9, 4.5); c.fillRect(x + w - 43, 5.2, 1.2, 2); c.textAlign = 'left';
  }
  function docWin(c, x, y, w, h, t) { // a proposal in a word processor
    var r = rnd(3); winChrome(c, x, y, w, h, 'Q4 Proposal.docx');
    c.fillStyle = '#f6f6f8'; c.fillRect(x, y + 17.6, w, 14); c.fillStyle = '#8e8e93'; c.font = '6px ' + UIF;
    ['Body', 'B', 'I', 'U', '•', '12 pt'].forEach(function (s, i) { c.fillText(s, x + 12 + i * 22, y + 27); });
    var px = x + 26, pw = w - 52;
    c.fillStyle = '#1d1d1f'; c.font = '700 14px ' + UIF; c.fillText('Q4 Proposal', px, y + 56);
    c.fillStyle = '#636366'; c.font = '6.5px ' + UIF; c.fillText('Draft 3 · shared with the team', px, y + 67);
    c.fillStyle = '#c7c7cc'; textLines(c, px, y + 78, pw, 9, r);
    c.fillStyle = '#1d1d1f'; c.font = '600 9px ' + UIF; c.fillText('Timeline', px, y + 156);
    c.fillStyle = '#c7c7cc'; textLines(c, px, y + 164, pw, 7, r);
    c.fillStyle = '#1d1d1f'; c.font = '600 9px ' + UIF; c.fillText('Budget', px, y + 228);
    c.fillStyle = '#c7c7cc'; textLines(c, px, y + 236, pw, M.max(0, M.floor((h - 250) / 7.5)), r);
    if (M.floor(t * 1.6) % 2 === 0) { c.fillStyle = '#0071e3'; c.fillRect(px + pw * .46, y + 207, 1.2, 8); }
  }
  function notesWin(c, x, y, w, h, t) { // a report with a photo
    var r = rnd(11); winChrome(c, x, y, w, h, 'Field Notes.pages');
    var px = x + 22, pw = w - 44;
    c.fillStyle = '#1d1d1f'; c.font = '700 13px ' + UIF; c.fillText('Coastline survey', px, y + 42);
    c.save(); rr(c, px, y + 52, pw, 104, 4); c.clip();
    if (ok(COAST)) { var iw = COAST.naturalWidth, ih = COAST.naturalHeight, ar = pw / 104, sw = M.min(iw, ih * ar), sh = sw / ar; c.drawImage(COAST, (iw - sw) * (.5 + .08 * M.sin(t * .15)), (ih - sh) * .55, sw, sh, px, y + 52, pw, 104); }
    else { var g = c.createLinearGradient(0, y + 52, 0, y + 156); g.addColorStop(0, '#7fb2d9'); g.addColorStop(1, '#2c5d7a'); c.fillStyle = g; c.fillRect(px, y + 52, pw, 104); }
    c.restore();
    c.fillStyle = '#636366'; c.font = '6px ' + UIF; c.fillText('Fig. 1 — north headland, morning light', px, y + 166);
    c.fillStyle = '#c7c7cc'; textLines(c, px, y + 176, pw, M.max(0, M.floor((h - 186) / 7.5)), r);
  }
  var SHEET = [['Hardware', 4820, 5210, 4995, 5600], ['Software', 2310, 2480, 2650, 2700], ['Travel', 980, 1120, 860, 1300], ['Shipping', 1540, 1610, 1720, 1810], ['Services', 3200, 3350, 3410, 3600], ['Training', 640, 700, 760, 820]];
  (function () { var tot = ['Total', 0, 0, 0, 0]; SHEET.forEach(function (v) { for (var q = 1; q < 5; q++) tot[q] += v[q]; }); SHEET.push(tot); })();
  function sheetWin(c, x, y, w, h, t) { // a budget spreadsheet with a chart
    winChrome(c, x, y, w, h, 'Budget 2027.xlsx');
    c.fillStyle = '#f6f6f8'; c.fillRect(x, y + 17.6, w, 13); c.fillStyle = '#8e8e93'; c.font = 'italic 6.5px ' + UIF; c.fillText('fx', x + 10, y + 26.6);
    c.fillStyle = '#1d1d1f'; c.font = '6.5px ' + UIF; c.fillText('=SUM(C2:C7)', x + 24, y + 26.6);
    var gx0 = x + 20, gy0 = y + 31, rh = 13.5, cw = (w - 26) / 7, rows = 9;
    c.fillStyle = '#f5f5f7'; c.fillRect(x, gy0, w, rh); c.fillRect(x, gy0, 20, rows * rh);
    c.fillStyle = '#6e6e73'; c.font = '600 6px ' + UIF; c.textAlign = 'center';
    for (var j = 0; j < 7; j++) c.fillText('ABCDEFG'[j], gx0 + cw * j + cw / 2, gy0 + 9.3);
    for (var i = 1; i < rows; i++) c.fillText(i, x + 10, gy0 + i * rh + 9.3);
    var hi = M.floor(t * .9) % 28, hr = 1 + hi % 7, hc = 1 + (M.floor(hi / 7) % 4);
    c.fillStyle = 'rgba(0,113,227,.08)'; c.fillRect(gx0 + cw * hc, gy0 + (hr + 1) * rh, cw, rh);
    c.font = '600 7px ' + UIF; c.fillStyle = '#1d1d1f'; c.textAlign = 'left'; c.fillText('Category', gx0 + 4, gy0 + rh + 9.5); c.textAlign = 'right';
    ['Q1', 'Q2', 'Q3', 'Q4', 'Total', 'Δ Q1–Q4'].forEach(function (s, k) { c.fillText(s, gx0 + cw * (k + 2) - 4, gy0 + rh + 9.5); });
    SHEET.forEach(function (v, n) {
      var yy = gy0 + (n + 2) * rh + 9.5, last = n === SHEET.length - 1, sum = v[1] + v[2] + v[3] + v[4], d = (v[4] - v[1]) / v[1] * 100;
      c.font = (last ? '600 ' : '') + '7px ' + UIF; c.fillStyle = '#1d1d1f'; c.textAlign = 'left'; c.fillText(v[0], gx0 + 4, yy); c.textAlign = 'right';
      for (var k = 1; k < 5; k++) c.fillText('$' + v[k].toLocaleString('en-US'), gx0 + cw * (k + 1) - 4, yy);
      c.fillText('$' + sum.toLocaleString('en-US'), gx0 + cw * 6 - 4, yy);
      c.fillStyle = d >= 0 ? '#146b2e' : '#c4302b'; c.fillText((d >= 0 ? '+' : '') + d.toFixed(1) + '%', gx0 + cw * 7 - 4, yy);
    });
    c.textAlign = 'left'; c.fillStyle = 'rgba(0,0,0,.08)';
    for (i = 0; i <= rows; i++) c.fillRect(x, gy0 + i * rh, w, .5);
    for (j = 0; j <= 7; j++) c.fillRect(gx0 + cw * j, gy0, .5, rows * rh);
    c.fillStyle = 'rgba(0,0,0,.14)'; c.fillRect(x, gy0 + 8 * rh, w, .8);
    c.strokeStyle = '#0071e3'; c.lineWidth = 1.4; c.strokeRect(gx0 + cw * hc + .7, gy0 + (hr + 1) * rh + .7, cw - 1.4, rh - 1.4);
    // chart under the grid
    var cx = x + 22, cy = gy0 + rows * rh + 16, chW = w - 44, base = y + h - 12, chH = base - cy - 8;
    c.fillStyle = '#1d1d1f'; c.font = '600 7.5px ' + UIF; c.fillText('Spend by quarter', cx, cy);
    var cols4 = ['#0071e3', '#33a1ff', '#7c4dff', '#00c7a0'], gw = chW / 6;
    for (var q = 0; q < 4; q++) { c.fillStyle = cols4[q]; c.fillRect(cx + chW - 128 + q * 32, cy - 5, 5, 5); c.fillStyle = '#6e6e73'; c.font = '6px ' + UIF; c.fillText('Q' + (q + 1), cx + chW - 121 + q * 32, cy); }
    for (q = 0; q < 4; q++) for (var k2 = 0; k2 < 6; k2++) {
      var bh = SHEET[k2][q + 1] / 5600 * chH * (.94 + .06 * M.sin(t * .8 + k2 + q)), bw = M.min(9, gw / 6);
      c.fillStyle = cols4[q]; rr(c, cx + k2 * gw + gw / 2 - bw * 2.2 + q * bw * 1.1, base - bh, bw, bh, 1.5); c.fill();
    }
    c.fillStyle = 'rgba(0,0,0,.12)'; c.fillRect(cx, base, chW, .6);
  }

  /* ---------- painting content through a screen map (vertical slices) ---------- */
  function mapPaint(c, map, src, r) {
    var cols = map.cols, X0 = r.x + map.x0 * r.w, X1 = r.x + map.x1 * r.w, sw = src.width, sh = src.height, j = 0, step = 1.5 / dpr;
    c.save(); c.beginPath(); // clip to the exact screen outline (anti-aliased edges)
    for (var i = 0; i < cols.length; i++) c.lineTo(r.x + cols[i].x * r.w, r.y + cols[i].top * r.h);
    for (i = cols.length - 1; i >= 0; i--) c.lineTo(r.x + cols[i].x * r.w, r.y + cols[i].bottom * r.h);
    c.closePath(); c.clip();
    for (var px = X0; px < X1; px += step) {
      var cx = (px + step / 2 - r.x) / r.w;
      while (j < cols.length - 2 && cols[j + 1].x < cx) j++;
      var a = cols[j], b = cols[j + 1], t = clamp((cx - a.x) / (b.x - a.x || 1), 0, 1);
      var top = r.y + (a.top + (b.top - a.top) * t) * r.h, bot = r.y + (a.bottom + (b.bottom - a.bottom) * t) * r.h;
      var u = (px - X0) / (X1 - X0);
      c.drawImage(src, clamp(u * sw, 0, sw - 1), 0, M.max(1, step / (X1 - X0) * sw), sh, px, top - .5, step + .6, bot - top + 1);
    }
    c.restore();
  }
  // fit an image (aspect ar) inside the media area of the card
  function fitIn(W, H, ar, capB, padB, maxWf, phone) {
    var aw = W * maxWf, ah = H - capB - padB, w = M.min(aw, ah * ar), h = w / ar;
    return { x: (W - w) / 2, y: capB + (ah - h) * (phone ? .5 : .55), w: w, h: h };
  }
  function capBottom(card) { var p = card.el.querySelector('.hl-cap'); return p.offsetTop + p.offsetHeight; }

  /* a soft contact shadow lifts the black body off the light card */
  function drawBody(c, im, r) { c.save(); c.shadowColor = 'rgba(0,0,0,.16)'; c.shadowBlur = 24 * dpr; c.shadowOffsetY = 12 * dpr; c.drawImage(im, r.x, r.y, r.w, r.h); c.restore(); }

  /* a terminal / code window (the Laptop side of the split card) */
  function termWin(c, x, y, w, h, t) {
    var r = rnd(21); winChrome(c, x, y, w, h, 'Terminal');
    c.save(); rr(c, x, y + 17, w, h - 17, 0); c.clip(); c.fillStyle = '#16171c'; c.fillRect(x, y + 17, w, h - 17);
    var cols = ['#7aa7ff', '#33d6a6', '#ffb070', '#c792ea', '#e4e4e4'], ly = y + 30, n = M.max(1, M.floor((h - 34) / 9));
    for (var i = 0; i < n; i++) {
      var lx = x + 10 + (i % 5 === 3 ? 12 : 0), segs = 2 + M.floor(r() * 3);
      for (var q = 0; q < segs; q++) { var sw = 14 + r() * 56; if (lx + sw > x + w - 10) break; c.fillStyle = cols[M.floor(r() * cols.length)]; c.globalAlpha = .85; c.fillRect(lx, ly + i * 9, sw, 3); lx += sw + 6; }
    }
    c.globalAlpha = 1; if (M.floor(t * 1.6) % 2 === 0) { c.fillStyle = '#e4e4e4'; c.fillRect(x + 10, ly + n * 9 - 1, 5, 6); }
    c.restore();
  }

  /* ---------- the six cards ---------- */
  var AR_FRONT = 2364 / 1430, AR_34 = 1600 / 1533, AR_REAR = 2394 / 1545;
  var CARDS = {
    /* 3440 x 1440 split down the middle is two 1720 x 1440 halves. Each has 1720 x 1440 = 2,476,800 pixels, more than a whole 1080p screen (1920 x 1080 = 2,073,600). */
    pixels: { dur: 5.2, slug: 'front', ar: AR_FRONT, draw: function (c, W, H, t, s) {
      var e = es(t, 1.2, 2.6), r = s.r, hw = CW / 2;
      ribbons(sx, 0, 0, CW, CH, t * .5 + 1.2, 0);
      ss.setTransform(1, 0, 0, 1, 0, 0); ss.imageSmoothingQuality = 'high'; ss.drawImage(SC, 0, 0, CW * 2, CH * 2); ss.setTransform(2, 0, 0, 2, 0, 0);
      menubar(ss, 0, CW, 'Deco Gear', true);
      docWin(ss, 20, 30, hw - 30, CH - 46, t);
      sheetWin(ss, hw + 10, 30, hw - 30, CH - 46, t);
      if (e > 0) { // the divider and the two half-screen sizes arrive
        ss.fillStyle = 'rgba(255,255,255,' + (.85 * e) + ')'; ss.fillRect(hw - 1, 14, 2, CH - 14);
        ss.save(); ss.globalAlpha = e; ss.font = '600 10px ' + UIF; ss.textAlign = 'center';
        [[hw / 2, '1720 × 1440'], [hw * 1.5, '1720 × 1440']].forEach(function (L2) { var tw = ss.measureText(L2[1]).width + 26; rr(ss, L2[0] - tw / 2, CH - 36, tw, 20, 10); ss.fillStyle = 'rgba(8,8,16,.8)'; ss.fill(); ss.fillStyle = '#fff'; ss.fillText(L2[1], L2[0], CH - 22); });
        ss.restore();
      }
      ss.setTransform(1, 0, 0, 1, 0, 0);
      drawBody(c, s.im, r); mapPaint(c, MAPS.front, SS, r);
      label(c, W, r, e < .5 ? 'One 3440 × 1440 screen' : 'Two 1720 × 1440 halves', s);
    } },
    /* the screen seen from above: a drawing of the 31.9 in (810 mm) chord on a 1500R arc, to scale (the sag of a 1500 mm radius over 810 mm is 56 mm) */
    curve: { dur: 4.4, noimg: true, layout: function (W, H, capB, phone) {
      var w = W * (phone ? .9 : .78), h = w / 4.4; return { x: (W - w) / 2, y: capB + (phone ? 24 : 6) + (H - capB) * (phone ? .04 : .02), w: w, h: h };
    }, draw: function (c, W, H, t, s) {
      var r = s.r, a0 = es(t, 0, .9);
      var half0 = r.w * .496, K = half0 / 405.13, Rad0 = 1500 * K, sag0 = Rad0 - M.sqrt(Rad0 * Rad0 - half0 * half0);
      var L = { x: r.x + r.w * .004, y: r.y + r.h * .9 }, R = { x: r.x + r.w * .996, y: r.y + r.h * .9 }, C = { x: r.x + r.w * .5, y: r.y + r.h * .9 - sag0 };
      var oy0 = C.y + Rad0, ang0 = M.asin(half0 / Rad0), lw0 = r.w * .026, path0 = function () { c.beginPath(); c.arc(C.x, oy0, Rad0 + lw0 / 2, -M.PI / 2 - ang0, -M.PI / 2 + ang0); };
      c.save(); c.globalAlpha = a0; c.lineCap = 'round';
      c.shadowColor = 'rgba(0,0,0,.18)'; c.shadowBlur = 18; c.shadowOffsetY = 8 + 10 * (1 - a0);
      c.strokeStyle = '#1d1d1f'; c.lineWidth = lw0; path0(); c.stroke(); c.restore();
      var you = { x: C.x, y: M.min(H - (s.phone ? 70 : 64), C.y + r.w * (s.phone ? .62 : .34)) };
      var e1 = es(t, .8, 2.0), e2 = es(t, 1.8, 3.2), e3 = es(t, 2.8, 3.8);
      // sight lines from you to the left end and the right end
      c.save(); c.lineCap = 'round';
      [L, R].forEach(function (P, i) {
        var q = clamp(e2 * 1.25 - i * .12, 0, 1); if (q <= 0) return;
        c.strokeStyle = 'rgba(0,113,227,.9)'; c.lineWidth = s.phone ? 1.5 : 2; c.setLineDash([2, 6]);
        c.beginPath(); c.moveTo(you.x, you.y); c.lineTo(lerp(you.x, P.x, q), lerp(you.y, P.y, q)); c.stroke();
      });
      c.setLineDash([]);
      // the curve traced along the glass
      if (e1 > 0) {
        var sag = L.y - C.y, half = (R.x - L.x) / 2, Rad = (half * half + sag * sag) / (2 * sag), oy = C.y + Rad, ang = M.asin(half / Rad);
        c.strokeStyle = '#0071e3'; c.lineWidth = s.phone ? 3 : 4; c.shadowColor = 'rgba(0,113,227,.45)'; c.shadowBlur = 12;
        c.beginPath(); c.arc(C.x, oy, Rad + (s.phone ? 3 : 5), -M.PI / 2 - ang * e1, -M.PI / 2 + ang * e1); c.stroke(); c.shadowBlur = 0;
      }
      // you
      c.fillStyle = 'rgba(0,113,227,' + e2 + ')'; c.beginPath(); c.arc(you.x, you.y, (s.phone ? 6 : 8) * e2, 0, 7); c.fill();
      c.fillStyle = 'rgba(0,113,227,' + .16 * e2 + ')'; c.beginPath(); c.arc(you.x, you.y, (s.phone ? 16 : 22) * e2, 0, 7); c.fill();
      c.font = '400 ' + (s.phone ? 13 : 15) + 'px -apple-system,BlinkMacSystemFont,sans-serif'; c.textAlign = 'center'; c.fillStyle = 'rgba(110,110,115,' + e2 + ')'; c.fillText('You', you.x, you.y + (s.phone ? 34 : 44));
      c.globalAlpha = e3; c.font = '600 ' + (s.phone ? 30 : 44) + 'px -apple-system,BlinkMacSystemFont,"SF Pro Display",sans-serif'; c.fillStyle = '#1d1d1f';
      var ly = lerp(C.y, you.y, .5) + (s.phone ? 10 : 14) + 8 * (1 - e3);
      c.save(); c.lineJoin = 'round'; c.strokeStyle = '#f7f7f9'; c.lineWidth = 9; c.strokeText('31.9 in wide', C.x, ly); c.restore(); c.fillText('31.9 in wide', C.x, ly);
      c.font = '400 ' + (s.phone ? 13 : 15) + 'px -apple-system,BlinkMacSystemFont,sans-serif'; c.fillStyle = '#6e6e73'; c.save(); c.lineJoin = 'round'; c.strokeStyle = '#f7f7f9'; c.lineWidth = 6; c.strokeText('21:9, 1500R curve', C.x, ly + (s.phone ? 22 : 28)); c.restore(); c.fillText('21:9, 1500R curve', C.x, ly + (s.phone ? 22 : 28));
      c.restore();
    } },
    /* 180 Hz (over DisplayPort) is one new frame every 5.6 ms; 60 Hz is one every 16.7 ms. In 100 ms that is 18 frames against 6 (frames start at 0 ms, then every 5.6 ms or every 16.7 ms). Arithmetic only. */
    hz: { dur: 5.2, slug: 'front', ar: AR_FRONT, draw: function (c, W, H, t, s) {
      var r = s.r, T = 100 * es(t, .7, 3.9), x0 = 340, x1 = CW - 56, tw = x1 - x0;
      ribbons(sx, 0, 0, CW, CH, t * .35 + 4.2, 0);
      sx.fillStyle = 'rgba(6,7,22,.86)'; sx.fillRect(0, 0, CW, CH);
      sx.textBaseline = 'alphabetic'; sx.textAlign = 'left';
      sx.fillStyle = 'rgba(255,255,255,.6)'; sx.font = '500 26px ' + UIF; sx.fillText('Frames in 100 ms', 52, 74);
      [{ hz: 60, ms: 1000 / 60, y: 198, col: '#8ab4ff', lab: '16.7 ms' }, { hz: 180, ms: 1000 / 180, y: 372, col: '#33d6a6', lab: '5.6 ms' }].forEach(function (L) {
        var n = M.round(100 / L.ms - .01), done = 0, k, X;
        for (k = 0; k < n; k++) if (k * L.ms <= T + 1e-6) done++;
        sx.fillStyle = '#fff'; sx.font = '600 58px ' + UIF; sx.fillText(L.hz + ' Hz', 52, L.y + 6);
        sx.fillStyle = 'rgba(255,255,255,.72)'; sx.font = '500 28px ' + UIF; sx.fillText(done + (done === 1 ? ' frame' : ' frames'), 54, L.y + 46);
        sx.fillStyle = 'rgba(255,255,255,.14)'; sx.fillRect(x0, L.y + 58, tw, 2);
        for (k = 0; k < n; k++) {
          X = x0 + k * L.ms / 100 * tw; var on = k * L.ms <= T + 1e-6, age = on ? clamp((T - k * L.ms) / 9, 0, 1) : 1, g2 = on ? 1 - age : 0;
          sx.save(); if (g2 > 0) { sx.shadowColor = L.col; sx.shadowBlur = 26 * g2; }
          sx.fillStyle = on ? L.col : 'rgba(255,255,255,.2)'; rr(sx, X - 6, L.y - 46, 12, 104, 6); sx.fill(); sx.restore();
        }
        if (T > L.ms + 1) { // the gap between two frames
          var xa = x0, xb = x0 + L.ms / 100 * tw, ga = es(T, L.ms + 1, L.ms + 8);
          sx.save(); sx.globalAlpha = ga; sx.strokeStyle = 'rgba(255,255,255,.85)'; sx.lineWidth = 2; sx.beginPath(); sx.moveTo(xa, L.y - 66); sx.lineTo(xb, L.y - 66); sx.moveTo(xa, L.y - 74); sx.lineTo(xa, L.y - 58); sx.moveTo(xb, L.y - 74); sx.lineTo(xb, L.y - 58); sx.stroke();
          sx.fillStyle = '#fff'; sx.font = '600 24px ' + UIF; sx.textAlign = 'left'; sx.fillText(L.lab, xb + 14, L.y - 56); sx.restore();
        }
      });
      var px = x0 + T / 100 * tw; sx.fillStyle = 'rgba(255,255,255,.9)'; sx.fillRect(px - 1, 112, 2, 350);
      sx.fillStyle = 'rgba(255,255,255,.5)'; sx.font = '500 22px ' + UIF; sx.textAlign = 'left'; sx.fillText('0 ms', x0 - 12, 500); sx.textAlign = 'right'; sx.fillText('100 ms', x1 + 12, 500); sx.textAlign = 'left';
      drawBody(c, s.im, r); mapPaint(c, MAPS.front, SC, r);
    } },
    /* a night scene: the bright moon and stars against black, with the two figures from the specifications (3000:1 static contrast, 100% sRGB) */
    contrast: { dur: 5.0, slug: 'front-34', ar: AR_34, layout: function (W, H, capB, phone) {
      var h = (H - capB - (phone ? 26 : 34)) / .8, w = h * AR_34; if (w > W * .96) { w = W * .96; h = w / AR_34; }
      return { x: (W - w) / 2, y: capB + (phone ? 14 : 18), w: w, h: h };
    }, draw: function (c, W, H, t, s) {
      var r = s.r, i, g = sx.createLinearGradient(0, 0, 0, CH);
      g.addColorStop(0, '#000104'); g.addColorStop(.62, '#04061a'); g.addColorStop(1, '#0a1030'); sx.fillStyle = g; sx.fillRect(0, 0, CW, CH);
      var rn = rnd(7); for (i = 0; i < 170; i++) { var X = rn() * CW, Y = rn() * CH * .68, R = .8 + rn() * 1.8, al = .35 + .65 * rn(), sp = 1 + rn() * 2; sx.fillStyle = 'rgba(255,255,255,' + al * (.55 + .45 * M.sin(t * sp + i)) + ')'; sx.fillRect(X, Y, R, R); }
      var mx = CW * .875, my = CH * .27, mg = sx.createRadialGradient(mx, my, 10, mx, my, 190); mg.addColorStop(0, 'rgba(255,244,214,.5)'); mg.addColorStop(1, 'rgba(255,244,214,0)'); sx.fillStyle = mg; sx.fillRect(mx - 200, my - 200, 400, 400);
      sx.fillStyle = '#fff6df'; sx.beginPath(); sx.arc(mx, my, 54, 0, 7); sx.fill();
      sx.fillStyle = 'rgba(190,178,150,.35)'; [[-18, -10, 11], [14, 8, 15], [-6, 24, 7], [20, -22, 8]].forEach(function (q) { sx.beginPath(); sx.arc(mx + q[0], my + q[1], q[2], 0, 7); sx.fill(); });
      sx.fillStyle = '#000'; sx.beginPath(); sx.moveTo(0, CH);
      for (i = 0; i <= 43; i++) { var x = i / 43 * CW; sx.lineTo(x, CH * .8 - (46 * M.abs(M.sin(i * .62)) + 30 * M.abs(M.sin(i * 1.7 + 1)) + 14) * (.6 + .4 * M.abs(M.sin(i * .21)))); }
      sx.lineTo(CW, CH); sx.closePath(); sx.fill();
      [['3000:1', 'contrast'], ['100%', 'sRGB']].forEach(function (it, i2) {
        var a = es(t, .7 + i2 * .6, 1.5 + i2 * .6), pw = 330, ph = 196, px = CW * (.27 + .3 * i2) - pw / 2, py = CH * .5 - ph / 2 + 14 * (1 - a);
        sx.save(); sx.globalAlpha = a; rr(sx, px, py, pw, ph, 30); sx.fillStyle = 'rgba(7,8,26,.62)'; sx.fill();
        sx.strokeStyle = 'rgba(255,255,255,.28)'; sx.lineWidth = 2; sx.stroke();
        sx.fillStyle = '#fff'; sx.textAlign = 'center'; sx.textBaseline = 'alphabetic';
        sx.font = '600 ' + (i2 ? 104 : 84) + 'px -apple-system,BlinkMacSystemFont,"SF Pro Display",sans-serif'; sx.fillText(it[0], px + pw / 2, py + 112);
        sx.font = '500 44px -apple-system,BlinkMacSystemFont,"SF Pro Text",sans-serif'; sx.fillStyle = 'rgba(255,255,255,.85)'; sx.fillText(it[1], px + pw / 2, py + 168);
        sx.restore();
      });
      sx.textAlign = 'left';
      drawBody(c, s.im, r); mapPaint(c, MAPS['front-34'], SC, r);
    } },
    /* Four video inputs: four cables run up from the bottom edge to the port bay at the bottom centre of the back. The cables and the one pill label the group of inputs (2 x HDMI 2.0, 2 x DisplayPort 1.4); the render does not mark which port is which, so none is singled out. */
    inputs: { dur: 4.8, slug: 'rear', ar: AR_REAR, wf: .78, draw: function (c, W, H, t, s) {
      var r = s.r, on = es(t, 2.9, 3.5), pulse = es(t, 2.6, 3.2), xs = [.335, .4, .6, .665], k, i, N = 60, shade = ['#2a2a2d', '#323236', '#2a2a2d', '#323236'];
      drawBody(c, s.im, r);
      c.save(); c.lineCap = 'round'; c.lineJoin = 'round';
      for (k = 0; k < 4; k++) {
        var e = es(t, .4 + k * .3, 1.9 + k * .3), P = { x: r.x + r.w * xs[k], y: r.y + r.h * .705 }, A = { x: r.x + r.w * (.5 + (xs[k] - .5) * 2.1), y: H + 24 };
        var B = { x: A.x, y: lerp(A.y, P.y, .55) }, D = { x: P.x, y: lerp(A.y, P.y, .62) }, n = M.max(2, M.round(N * e)), pts = [];
        for (i = 0; i <= N; i++) { var u = i / N, v = 1 - u; pts.push({ x: v * v * v * A.x + 3 * v * v * u * B.x + 3 * v * u * u * D.x + u * u * u * P.x, y: v * v * v * A.y + 3 * v * v * u * B.y + 3 * v * u * u * D.y + u * u * u * P.y }); }
        if (e > 0) {
          c.strokeStyle = shade[k]; c.lineWidth = s.phone ? 3.4 : 5; c.shadowColor = 'rgba(0,0,0,.28)'; c.shadowBlur = 7; c.shadowOffsetY = 3;
          c.beginPath(); for (i = 0; i < n; i++) i ? c.lineTo(pts[i].x, pts[i].y) : c.moveTo(pts[i].x, pts[i].y); c.stroke(); c.shadowColor = 'transparent';
          if (e > .98) { c.fillStyle = '#4a4a50'; rr(c, P.x - (s.phone ? 5 : 7), P.y - (s.phone ? 4 : 6), s.phone ? 10 : 14, s.phone ? 9 : 12, 2); c.fill(); }
        }
        if (pulse > 0) { // signal flowing up each cable
          var q = ((t - 2.6) * .45 + k / 4) % 1; if (q >= 0) { var p = pts[M.floor(q * N)]; c.fillStyle = 'rgba(0,113,227,' + (.9 * pulse * M.sin(q * M.PI)) + ')'; c.beginPath(); c.arc(p.x, p.y, s.phone ? 2.4 : 3.2, 0, 7); c.fill(); }
        }
      }
      c.restore();
      if (on > 0) {
        c.save(); c.globalAlpha = on; var fs = s.phone ? 13 : 15, tx = s.phone ? '2 × HDMI 2.0  ·  2 × DP 1.4' : '2 × HDMI 2.0  ·  2 × DisplayPort 1.4'; c.font = '600 ' + fs + 'px -apple-system,BlinkMacSystemFont,sans-serif';
        var tw = c.measureText(tx).width + (s.phone ? 26 : 36), th = s.phone ? 30 : 36, cx2 = (W - tw) / 2, cy2 = H - th - (s.phone ? 14 : 18) - 4 * (1 - on);
        c.fillStyle = 'rgba(255,255,255,.97)'; c.shadowColor = 'rgba(0,0,0,.18)'; c.shadowBlur = 16; rr(c, cx2, cy2, tw, th, th / 2); c.fill(); c.shadowColor = 'transparent';
        c.fillStyle = '#1d1d1f'; c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillText(tx, cx2 + tw / 2, cy2 + th / 2 + .5); c.restore();
      }
    } },
    /* picture-by-picture: two inputs side by side. The "PC" and "Laptop" labels are the names of the two sources. */
    split: { dur: 5.0, slug: 'front', ar: AR_FRONT, draw: function (c, W, H, t, s) {
      var e = es(t, 1.0, 2.8), lab = es(t, 2.6, 3.4), r = s.r, half = CW / 2, cx = CW - e * half;
      // source 1, the PC: the page's ribbons, a document and a spreadsheet; it owns the whole screen until the second source arrives
      ribbons(sx, 0, 0, CW, CH, t * .5 + 1.2, 0);
      ss.setTransform(1, 0, 0, 1, 0, 0); ss.imageSmoothingQuality = 'high'; ss.drawImage(SC, 0, 0, CW * 2, CH * 2); ss.setTransform(2, 0, 0, 2, 0, 0);
      menubar(ss, 0, CW, 'Deco Gear', true);
      docWin(ss, 22, 36, 236, CH - 60, t); sheetWin(ss, 270, 36, 360, CH - 60, t);
      // source 2, the laptop: its own wallpaper phase, a notes window and a terminal, wiping in from the right edge
      if (e > 0) {
        ss.save(); ss.beginPath(); ss.rect(cx, 0, CW - cx, CH); ss.clip();
        ribbons(sx, 0, 0, CW, CH, t * .5 + 8.4, 0);
        ss.setTransform(1, 0, 0, 1, 0, 0); ss.drawImage(SC, 0, 0, CW * 2, CH * 2); ss.setTransform(2, 0, 0, 2, 0, 0);
        menubar(ss, half, half, 'Laptop', true);
        notesWin(ss, half + 22, 36, 300, CH - 60, t); termWin(ss, half + 336, 36, 282, CH - 60, t);
        ss.restore();
        ss.fillStyle = '#050506'; ss.fillRect(cx - 3, 0, 6, CH);
      }
      if (lab > 0) {
        ss.save(); ss.globalAlpha = lab; ss.font = '600 9px ' + UIF; ss.textAlign = 'center';
        [['PC', half / 2], ['Laptop', half * 1.5]].forEach(function (L2) { var tw = ss.measureText(L2[0]).width + 20; rr(ss, L2[1] - tw / 2, CH - 30, tw, 18, 9); ss.fillStyle = 'rgba(8,8,16,.72)'; ss.fill(); ss.fillStyle = '#fff'; ss.fillText(L2[0], L2[1], CH - 17.5); });
        ss.restore();
      }
      ss.setTransform(1, 0, 0, 1, 0, 0);
      drawBody(c, s.im, r); mapPaint(c, MAPS.front, SS, r);
    } }
  };
  function label(c, W, r, txt, s, big) {
    var fs = big ? (s.phone ? 26 : 36) : (s.phone ? 13 : 15);
    c.save(); c.font = (big ? '600 ' : '400 ') + fs + 'px -apple-system,BlinkMacSystemFont,"SF Pro Display",sans-serif'; c.textAlign = 'center'; c.textBaseline = 'top';
    c.fillStyle = big ? '#1d1d1f' : '#6e6e73'; c.fillText(txt, W / 2, r.y + r.h + (s.phone ? 18 : 26)); c.restore();
  }

  /* ---------- state ---------- */
  var st = cards.map(function (el, i) { return { el: el, i: i, k: el.getAttribute('data-k'), cv: el.querySelector('canvas'), t: 0, W: 0, H: 0 }; });
  var active = 0, playing = !RM, inView = false, raf = 0, last = 0, hold = 0, dirty = true, started = false;
  var dots = st.map(function (s, i) { var b = document.createElement('button'); b.type = 'button'; b.className = 'hl-dot'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', s.el.querySelector('.hl-cap').firstChild.textContent.trim()); b.innerHTML = '<i><b></b></i>'; b.onclick = function () { go(i, true); }; dotsEl.appendChild(b); return b; });
  IM.coast = img('coast', (window.DGX&&DGX["dgx-duo-coast-l340.jpg"])||'dgx-duo-coast-l340.jpg');

  function size(s) {
    var W = s.el.clientWidth, H = s.el.clientHeight; if (!W || !H) return;
    var phone = W < 600, def = CARDS[s.k], capB = capBottom(s);
    if (W !== s.W || H !== s.H) { s.W = W; s.H = H; s.cv.width = M.round(W * dpr); s.cv.height = M.round(H * dpr); }
    s.phone = phone;
    s.r = def.layout ? def.layout(W, H, capB, phone) : fitIn(W, H, def.ar, capB + (phone ? 18 : 26), phone ? 66 : 62, phone ? .94 : (def.wf || .72), phone);
    if (def.noimg) { s.im = s.im || { complete: true, naturalWidth: 1 }; return; } var need = M.ceil(s.r.w * dpr), src = pick(def.slug, need);
    if (!s.im || s.src !== src) { var im = img(src, src); if (!s.im || ok(im)) s.im = im; else im.onload = function () { s.im = im; dirty = true; render(s); }; s.src = src; }
  }
  function render(s) {
    if (!MAPS || !s.r || !ok(s.im)) return;
    var c = s.cv.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, s.W, s.H);
    c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
    CARDS[s.k].draw(c, s.W, s.H, s.t + (s.t >= CARDS[s.k].dur ? (s.live || 0) : 0), s);
  }
  function setUI() {
    st.forEach(function (s, i) { s.el.classList.toggle('on', i === active); s.el.setAttribute('aria-hidden', i === active ? 'false' : 'true'); dots[i].classList.toggle('on', i === active); dots[i].setAttribute('aria-selected', i === active ? 'true' : 'false'); });
    var done = active === st.length - 1 && st[active].t >= CARDS[st[active].k].dur;
    playBtn.dataset.s = done && !playing ? 'replay' : playing ? 'pause' : 'play';
    playBtn.setAttribute('aria-label', playBtn.dataset.s === 'pause' ? 'Pause highlights' : playBtn.dataset.s === 'replay' ? 'Replay highlights' : 'Play highlights');
  }
  function progress() { var s = st[active]; dots[active].style.setProperty('--p', clamp(s.t / CARDS[s.k].dur, 0, 1)); }
  function go(i, user) {
    i = clamp(i, 0, st.length - 1); var prev = active; active = i;
    st[i].t = 0; st[i].live = 0; st[i].el.classList.add('seen'); hold = 0;
    var s = st[i], left = s.el.offsetLeft - (scroller.clientWidth - s.el.clientWidth) / 2;
    if (s.phone) left = s.el.offsetLeft - 22;
    programmatic = Date.now(); scroller.scrollTo({ left: left, behavior: RM ? 'auto' : 'smooth' });
    if (RM) s.t = CARDS[s.k].dur;
    if (prev !== i && st[prev]) { st[prev].t = CARDS[st[prev].k].dur; render(st[prev]); }
    setUI(); progress(); render(s); kick();
  }
  function tick(now) {
    raf = 0; var dt = last ? M.min(.05, (now - last) / 1000) : 0; last = now;
    var s = st[active], def = CARDS[s.k];
    if (playing && inView) {
      if (s.t < def.dur) { s.t = M.min(def.dur, s.t + dt); }
      else { hold += dt; if (hold > 1.6) { if (active < st.length - 1) go(active + 1); else { playing = false; setUI(); } } }
      progress();
    }
    // the cable's power pulse and the ribbons keep living after the timeline ends
    if (inView && !RM && s.t >= def.dur) s.live = (s.live || 0) + dt; // ribbons and the power pulse keep living
    if (inView && !RM) render(s);
    if (inView && !RM) raf = requestAnimationFrame(tick);
  }
  function kick() { if (!raf && inView && !RM) { last = 0; raf = requestAnimationFrame(tick); } }

  playBtn.onclick = function () {
    if (playBtn.dataset.s === 'replay') { playing = true; go(0, true); return; }
    playing = !playing; if (playing && st[active].t >= CARDS[st[active].k].dur) { if (active < st.length - 1) go(active + 1); else st[active].t = 0; }
    setUI(); kick();
  };
  // manual swipes: the card nearest the centre becomes active
  var programmatic = 0, sT = 0;
  scroller.addEventListener('scroll', function () {
    clearTimeout(sT); sT = setTimeout(function () {
      if (Date.now() - programmatic < 700) return;
      var mid = scroller.scrollLeft + scroller.clientWidth / 2, best = 0, bd = 1e9;
      st.forEach(function (s, i) { var c = s.el.offsetLeft + s.el.clientWidth / 2, d = M.abs(c - mid); if (st[0].phone) d = M.abs(s.el.offsetLeft - 22 - scroller.scrollLeft); if (d < bd) { bd = d; best = i; } });
      if (best !== active) { playing = false; var prev = active; active = best; st[best].t = 0; st[best].el.classList.add('seen'); hold = 0; st[prev].t = CARDS[st[prev].k].dur; render(st[prev]); playing = !RM; setUI(); kick(); }
    }, 120);
  }, { passive: true });
  scroller.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(active + 1, true); e.preventDefault(); } if (e.key === 'ArrowLeft') { go(active - 1, true); e.preventDefault(); } });

  function layoutAll() { st.forEach(function (s) { size(s); if (s !== st[active] || RM) render(s); }); }
  var rT; window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () { layoutAll(); render(st[active]); }, 120); });

  function start() {
    if (started) return; started = true;
    fetch(DGWI.maps).then(function (r) { return r.json(); }).then(function (m) {
      MAPS = m;
      st.forEach(function (s) { s.t = RM ? CARDS[s.k].dur : 0; });
      layoutAll();
      // inactive cards show their finished frame (like a paused video's poster)
      st.forEach(function (s, i) { if (i !== active) { s.t = CARDS[s.k].dur; } var im = s.im; if (!ok(im)) im.addEventListener('load', function () { render(s); }); else render(s); });
      st[0].el.classList.add('seen'); setUI(); progress(); kick();
    }).catch(function () {});
  }
  var heads = [].slice.call(root.querySelectorAll('.dgx-reveal'));
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es2) { es2.forEach(function (en) { if (en.isIntersecting) en.target.classList.add('in'); }); }, { threshold: .2 }).observe(heads[0]);
    if (heads[1]) heads[1].classList.add('in');
    new IntersectionObserver(function (es2) { es2.forEach(function (en) { if (en.isIntersecting) { start(); } }); }, { rootMargin: '600px 0px' }).observe(root);
    new IntersectionObserver(function (es2) { es2.forEach(function (en) { inView = en.isIntersecting; if (inView) kick(); }); }, { threshold: .35 }).observe(scroller);
  } else { heads.forEach(function (h) { h.classList.add('in'); }); inView = true; start(); }
  setUI();
  window.DG_HIGHLIGHTS = { go: go, state: function () { return { active: active, playing: playing, t: st[active].t }; }, seek: function (i, t) { active = i; st[i].t = t; st[i].el.classList.add('seen'); setUI(); progress(); var s = st[i]; s.el.scrollIntoView && scroller.scrollTo({ left: s.phone ? s.el.offsetLeft - 22 : s.el.offsetLeft - (scroller.clientWidth - s.el.clientWidth) / 2 }); render(s); }, pause: function () { playing = false; setUI(); } };
})();

(function(){
 var root=document.getElementById('dg-design'); if(!root) return;
 var RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
 var stage=root.querySelector('.dsg-stage'),A=root.querySelector('.dsg-a'),B=root.querySelector('.dsg-b'),C=root.querySelector('.dsg-c');
 var calls=[].slice.call(root.querySelectorAll('.dsg-calls li')),replay=root.querySelector('.dsg-replay');
 var raf=0,played=false;
 // reveal
 var rv=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');rv.unobserve(e.target)}})},{rootMargin:'0px 0px -12% 0px'});
 root.querySelectorAll('.dgx-reveal').forEach(function(el){rv.observe(el)});
 var ease=function(t){return 1-Math.pow(1-t,3)};
 function seg(t,a,b){return Math.min(1,Math.max(0,(t-a)/(b-a)))}
 function lerp(a,b,t){return a+(b-a)*t}
 function env(t,a,b,c,d){return seg(t,a,b)*(1-seg(t,c,d))} // fade in a..b, hold, fade out c..d
 // the 34" renders carry every beat: slow push-ins and cross-fades, nothing is drawn or invented
 /* on a phone the stage is nearly square, so the push-ins are gentler and the whole monitor stays in frame */
 function Z(s){return window.innerWidth<735?1+(s-1)*.4:s}
 function photo(el,o,s,tx,ty){s=Z(s);el.style.opacity=o;el.style.visibility=o>0.001?'visible':'hidden';if(o>0.001)el.style.transform='translate('+tx+'%,'+ty+'%) scale('+s+')'}
 function setCall(i){calls.forEach(function(c,j){c.classList.toggle('on',j===i);c.classList.toggle('done',j<i&&i>=0)})}
 var DUR=11500;
 function render(t){ // t in 0..1
  // beat 1 (0-.32): the front, three-quarter view
  photo(A,1-seg(t,.29,.34),lerp(.97,1.05,ease(seg(t,0,.34))),lerp(0,-1,ease(seg(t,0,.34))),0);
  // beat 2 (.29-.58): the back, three-quarter view, pushing in on the sculpted panel and the stand mount
  var b=ease(seg(t,.28,.6));
  photo(B,env(t,.29,.34,.55,.6),lerp(1.04,1.2,b),lerp(0,2,b),lerp(0,1,b));
  // beat 3 (.55-1): straight-on rear, pushing in on the stand post and the VESA mount
  var c=ease(seg(t,.54,1));
  photo(C,seg(t,.55,.6),lerp(1.04,1.3,c),0,lerp(0,4,c));
  setCall(t<.03?-1:t<.5?0:t<.76?1:t<.97?2:3);
 }
 function play(){
  cancelAnimationFrame(raf); root.classList.remove('ended'); played=true;
  if(RM){render(1);calls.forEach(function(c){c.classList.add('done')});root.classList.add('ended');return}
  root.classList.add('playing');calls.forEach(function(c){c.classList.remove('done','on')});
  var t0=performance.now();
  (function f(now){var t=Math.min(1,(now-t0)/DUR); render(t); if(t<1)raf=requestAnimationFrame(f); else {root.classList.remove('playing');root.classList.add('ended');calls.forEach(function(c){c.classList.remove('on');c.classList.add('done')})}})(t0);
 }
 replay.addEventListener('click',play);
 render(0);
 window.DG_DESIGN={play:play,seek:function(t){cancelAnimationFrame(raf);played=true;root.classList.toggle('playing',t<1);root.classList.toggle('ended',t>=1);render(t)}};
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting&&!played)play()})},{threshold:.55});
 io.observe(stage);
})();

(function(){
 var root=document.getElementById('dg-viewer'); if(!root) return;
 var RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
 var gl=root.querySelector('.vw-gl'),cap=root.querySelector('.vw-cap'),tabs=[].slice.call(root.querySelectorAll('.vw-tabs button'));
 var shots={};root.querySelectorAll('.vw-shot').forEach(function(f){shots[f.dataset.for]=f});
 var V={
  front:{az:0,on:1,cap:'<b>3440 × 1440 on one curve.</b> A 34-inch, 21:9 VA panel with a 1500R curve.'},
  back:{az:180,cap:'<b>A 100 × 100 VESA mount.</b> Mount it on an arm or a wall.'},
  side:{az:80,cap:'<b>Tilt it to suit you.</b> The stand tilts from −5° to +15°.'}
 };
 var S=null,az=0,raf=0,praf=0,power=0,cur='front',looping=false;
 var rv=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');rv.unobserve(e.target)}})},{rootMargin:'0px 0px -10% 0px'});
 root.querySelectorAll('.dgx-reveal').forEach(function(el){rv.observe(el)});
 // screen: the same live colour ribbons + DECOGEAR logo as the hero
 var logo=new Image();logo.src=(window.DGX&&DGX["dgx-duo-logo-allwhite.svg"])||'dgx-duo-logo-allwhite.svg';
 function colour(x,w,h,t){DGRibbonsL340.draw(x,w,h,t,{logo:logo,logoAt:-1})}
 function startLoop(){if(!S||looping)return;looping=true;var t0=RM?0:12;S.screenLoop(function(x,w,h,t){colour(x,w,h,RM?0:t0+t)})}
 function stopLoop(){if(S&&looping){S.stopScreen();looping=false}}
 function fadePower(to,dur){cancelAnimationFrame(praf);var from=power,t0=performance.now();
  if(RM){power=to;S.setPower(to);return}
  (function f(n){var q=Math.min(1,(n-t0)/dur);q=q*q*(3-2*q);power=from+(to-from)*q;S.setPower(power);if(q<1)praf=requestAnimationFrame(f);else if(to===0)stopLoop()})(t0)}
 var ease=function(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2};
 function turn(to,done){cancelAnimationFrame(raf);
  var d=((to-az)%360+540)%360-180; var from=az,dist=Math.abs(d);
  if(RM||dist<.5){az=from+d;S.setAz(az);done&&done();return}
  var dur=Math.min(1700,500+dist*7),t0=performance.now();
  (function f(n){var q=Math.min(1,(n-t0)/dur);az=from+d*ease(q);S.setAz(az);if(q<1)raf=requestAnimationFrame(f);else done&&done()})(t0)}
 function show(k,initial){
  var v=V[k];if(!v)return;cur=k;
  tabs.forEach(function(b){var on=b.dataset.v===k;b.setAttribute('aria-selected',on?'true':'false');b.tabIndex=on?0:-1;if(on&&!initial){var bar=b.parentNode;if(bar.scrollWidth>bar.clientWidth)bar.scrollTo({left:b.offsetLeft-(bar.clientWidth-b.offsetWidth)/2,behavior:RM?'auto':'smooth'})}});
  if(initial)cap.innerHTML=v.cap;else{cap.classList.add('fade');setTimeout(function(){cap.innerHTML=v.cap;cap.classList.remove('fade')},260)}
  Object.keys(shots).forEach(function(s){shots[s].classList.toggle('on',s===v.shot)});
  root.classList.toggle('shot',!!v.shot);
  if(!S)return;
  if(v.on){startLoop();turn(v.az,function(){if(cur===k)fadePower(1,700)})}
  else{if(power>0)fadePower(0,350);turn(v.az)}
 }
 tabs.forEach(function(b,i){
  b.addEventListener('click',function(){show(b.dataset.v)});
  b.addEventListener('keydown',function(e){var j=e.key==='ArrowRight'?i+1:e.key==='ArrowLeft'?i-1:-1;if(j<0&&e.key!=='ArrowLeft')return;j=(j+tabs.length)%tabs.length;tabs[j].focus();show(tabs[j].dataset.v);e.preventDefault()});
 });
 // keep our azimuth in step with spin.js's own drag-to-turn
 var drag=null;
 gl.addEventListener('pointerdown',function(e){cancelAnimationFrame(raf);drag={x:e.clientX,az:az};root.classList.add('touched')});
 gl.addEventListener('pointermove',function(e){if(drag)az=drag.az-(e.clientX-drag.x)*.35});
 addEventListener('pointerup',function(){drag=null});
 /* this page's 3D body: the live 34" swoosh model, reused unchanged (mesh dgs-34swoosh-mesh.bin, views dgs-34swoosh-views.json) and its seven full-resolution textures
    (dgs-34swooshl340-*). The hero normally sets DG_SPIN_OPTS and DG_TEX_L340 (dg-spin-l340.js reads the latter); these defaults only fill in what it did not.
    No screen option is passed: dg-spin-l340.js carries this panel's lit-screen area. */
 function SPIN_DEFAULTS(){var B=window.DGX_BASE,t={};['front','front34r','front34l','sider','rear','rear34l','rear34r'].forEach(function(k){t[k]=B+'dgs-34swooshl340-'+k+'.webp'});return {mesh:B+'dgs-34swoosh-mesh.bin',views:B+'dgs-34swoosh-views.json',textures:t}}
 function wait(cb,n){n=n||0;if(window.DGSpin&&window.THREE)cb();else{
  if(n===20&&!window.DGSpin){var j=document.createElement('script');j.src=window.DGX_BASE+'dg-spin-l340.js';document.head.appendChild(j)}
  if(n===20&&!window.THREE){var k=document.createElement('script');k.src='https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';document.head.appendChild(k)}
  setTimeout(function(){wait(cb,n+1)},120)}}
 show('front',true);
 var mounted=false;
 var io=new IntersectionObserver(function(es){
  es.forEach(function(e){
   if(e.isIntersecting&&!mounted){mounted=true;wait(function(){window.DGSpin.mount(gl,Object.assign({},SPIN_DEFAULTS(),window.DG_SPIN_OPTS||{})).then(function(s){S=s;az=V[cur].az;S.setAz(az);root.classList.add('ready');window.DG_VIEWER={spin:S,show:show};show(cur,true)}).catch(function(){})})}
   else if(S&&V[cur].on){if(e.isIntersecting)startLoop();else stopLoop()}
  });
 },{rootMargin:'400px 0px'});
 io.observe(root.querySelector('.vw-stage'));
})();

(function(){
 var root=document.getElementById('dg-display'); if(!root) return;
 var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
 var IMG=DGWI.base;

 /* reveal */
 var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');rio.unobserve(e.target)}})},{rootMargin:'0px 0px -12% 0px'});
 root.querySelectorAll('.dgx-reveal').forEach(function(el){rio.observe(el)});

 /* screen-map painter: draws a 43:18 (3440 x 1440) source canvas onto the real glass of a factory render.
    u advances with dx/height so the far (smaller) end is foreshortened like real perspective. */
 function prepMap(m){var c=m.cols,u=[0],i;for(i=1;i<c.length;i++){var h0=c[i-1].bottom-c[i-1].top,h1=c[i].bottom-c[i].top;u.push(u[i-1]+(c[i].x-c[i-1].x)/((h0+h1)/2))}var t=u[u.length-1];for(i=0;i<u.length;i++)u[i]/=t;m.u=u;return m}
 function mapPaint(x,m,R,src,shine){
  var c=m.cols,u=m.u,SW=src.width,SH=src.height,i;
  for(i=0;i<c.length-1;i++){
   var X0=R.x+c[i].x*R.w,X1=R.x+c[i+1].x*R.w,T=R.y+(c[i].top+c[i+1].top)/2*R.h,B=R.y+(c[i].bottom+c[i+1].bottom)/2*R.h;
   var s0=u[i]*SW,s1=u[i+1]*SW;x.drawImage(src,s0,0,Math.max(.5,s1-s0),SH,X0,T,X1-X0+.75,B-T);
  }
  if(shine!==false){x.save();x.beginPath();for(i=0;i<c.length;i++)x.lineTo(R.x+c[i].x*R.w,R.y+c[i].top*R.h);for(i=c.length-1;i>=0;i--)x.lineTo(R.x+c[i].x*R.w,R.y+c[i].bottom*R.h);x.closePath();x.clip();
   var g=x.createLinearGradient(R.x,R.y,R.x+R.w*.35,R.y+R.h*.7);g.addColorStop(0,'rgba(255,255,255,.10)');g.addColorStop(.45,'rgba(255,255,255,.025)');g.addColorStop(.46,'rgba(255,255,255,0)');x.fillStyle=g;x.fillRect(R.x,R.y,R.w,R.h);x.restore()}
 }

 /* colour ribbons, full 43:18: the page's one shared look (same maths as the hero) */
 function ribbons(x,w,h,t,on){
  DGRibbonsL340.draw(x,w,h,t);
  if(on<1){ // power-on: light opens from the centre outward
   var r=on*on*(3-2*on);x.fillStyle='#000';var half=w/2*(1-r);x.globalAlpha=1;x.fillRect(0,0,half,h);x.fillRect(w-half,0,half,h);
   var gl=x.createLinearGradient(half-w*.05,0,half+w*.02,0);gl.addColorStop(0,'rgba(0,0,0,1)');gl.addColorStop(1,'rgba(0,0,0,0)');x.fillStyle=gl;x.fillRect(half-w*.05,0,w*.07,h);
   var gr=x.createLinearGradient(w-half+w*.05,0,w-half-w*.02,0);gr.addColorStop(0,'rgba(0,0,0,1)');gr.addColorStop(1,'rgba(0,0,0,0)');x.fillStyle=gr;x.fillRect(w-half-w*.02,0,w*.07,h)}
 }

 /* the big monitor */
 var mon=root.querySelector('.dsp-mon'),cv=root.querySelector('[data-dsp-canvas]'),ctx=cv.getContext('2d');
 var scr=document.createElement('canvas');scr.width=1920;scr.height=804;var sx=scr.getContext('2d');
 var map=null,img=new Image(),ready=0,visible=false,raf=0,t0=0,onAt=0;
 img.decoding='async';
 function pick(){var w=mon.clientWidth*Math.min(devicePixelRatio||1,2);return w>1700?2364:w>1000?1600:960}
 img.onload=function(){ready|=1;size();frame(performance.now())};
 fetch(DGWI.maps).then(function(r){return r.json()}).then(function(j){map=prepMap(j.front);ready|=2;frame(performance.now())}).catch(function(){});
 function size(){var d=Math.min(devicePixelRatio||1,2),w=mon.clientWidth,h=mon.clientHeight;cv.width=Math.round(w*d);cv.height=Math.round(h*d)}
 function frame(now){
  if(ready!==3)return;
  var t=RM?6:(now-t0)/1000,on=RM?1:Math.min(1,Math.max(0,(now-onAt)/1400));
  ribbons(sx,1920,804,t+6,onAt?on:0);
  ctx.clearRect(0,0,cv.width,cv.height);ctx.drawImage(img,0,0,cv.width,cv.height);
  mapPaint(ctx,map,{x:0,y:0,w:cv.width,h:cv.height},scr);
  mon.classList.add('live');
 }
 var last=0;
 function loop(now){raf=requestAnimationFrame(loop);if(now-last<33)return;last=now;frame(now)}
 var vio=new IntersectionObserver(function(es){es.forEach(function(e){visible=e.isIntersecting;
  if(visible){if(!img.src)img.src=IMG+'front-'+pick()+'.webp';
   if(!onAt){onAt=performance.now()+450;t0=performance.now()}
   if(!RM&&!raf)raf=requestAnimationFrame(loop);else if(RM)frame(performance.now())}
  else{cancelAnimationFrame(raf);raf=0}})},{rootMargin:'200px 0px'});
 vio.observe(mon);
 var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){if(ready&1){size();frame(performance.now())}},120)});

 /* comparison: two 1720 x 1440 half-screen outlines slide together and become one 21:9 3440 x 1440 panel */
 var card=root.querySelector('[data-dsp-compare]');
 var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){setTimeout(function(){card.classList.add('merge')},RM?0:700);cio.unobserve(card)}})},{threshold:.5});
 cio.observe(card);
 root.querySelector('[data-dsp-replay]').addEventListener('click',function(){card.classList.remove('merge');setTimeout(function(){card.classList.add('merge')},900)});

 window.DG_DISPLAY={mapPaint:mapPaint,prepMap:prepMap,ribbons:ribbons};
})();

(function(){
 var root=document.getElementById('dg-versatility'); if(!root) return;
 var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
 var M=Math,PI=M.PI;

 var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');rio.unobserve(e.target)}})},{rootMargin:'0px 0px -10% 0px'});
 root.querySelectorAll('.vrs-head .dgx-reveal').forEach(function(el){rio.observe(el)});
 root.querySelectorAll('.vrs-item').forEach(function(el){el.classList.add('dgx-reveal');rio.observe(el)});

 /* ---------- screen-map painter (same method as display.js) ---------- */
 function prepMap(m){var c=m.cols,u=[0],i;for(i=1;i<c.length;i++){var h0=c[i-1].bottom-c[i-1].top,h1=c[i].bottom-c[i].top;u.push(u[i-1]+(c[i].x-c[i-1].x)/((h0+h1)/2))}var t=u[u.length-1];for(i=0;i<u.length;i++)u[i]/=t;m.u=u;return m}
 function mapPaint(x,m,R,src){
  var c=m.cols,u=m.u,SW=src.width,SH=src.height,i;
  for(i=0;i<c.length-1;i++){var X0=R.x+c[i].x*R.w,X1=R.x+c[i+1].x*R.w,T=R.y+(c[i].top+c[i+1].top)/2*R.h,B=R.y+(c[i].bottom+c[i+1].bottom)/2*R.h,s0=u[i]*SW,s1=u[i+1]*SW;x.drawImage(src,s0,0,M.max(.5,s1-s0),SH,X0,T,X1-X0+.75,B-T)}
  x.save();x.beginPath();for(i=0;i<c.length;i++)x.lineTo(R.x+c[i].x*R.w,R.y+c[i].top*R.h);for(i=c.length-1;i>=0;i--)x.lineTo(R.x+c[i].x*R.w,R.y+c[i].bottom*R.h);x.closePath();x.clip();
  var g=x.createLinearGradient(R.x,R.y,R.x+R.w*.35,R.y+R.h*.7);g.addColorStop(0,'rgba(255,255,255,.09)');g.addColorStop(.45,'rgba(255,255,255,.02)');g.addColorStop(.46,'rgba(255,255,255,0)');x.fillStyle=g;x.fillRect(R.x,R.y,R.w,R.h);x.restore();
 }

 /* ---------- helpers ---------- */
 function rr(c,x,y,w,h,r){c.beginPath();c.moveTo(x+r,y);c.arcTo(x+w,y,x+w,y+h,r);c.arcTo(x+w,y+h,x,y+h,r);c.arcTo(x,y+h,x,y,r);c.arcTo(x,y,x+w,y,r);c.closePath()}
 function lg(c,x0,y0,x1,y1,s){var g=c.createLinearGradient(x0,y0,x1,y1);for(var i=0;i<s.length;i+=2)g.addColorStop(s[i],s[i+1]);return g}
 function rnd(seed){var s=seed;return function(){s=(s*9301+49297)%233280;return s/233280}}
 var coast=new Image();coast.src=(window.DGX&&DGX["dgx-duo-coast-l340.jpg"])||'dgx-duo-coast-l340.jpg';
 function photo(c,x,y,w,h,fx,fy){ // a crop of the coast photo, or a gradient while it loads
  if(coast.complete&&coast.naturalWidth){var iw=coast.naturalWidth,ih=coast.naturalHeight,ar=w/h,sw=M.min(iw,ih*ar),sh=sw/ar;c.drawImage(coast,(iw-sw)*(fx==null?.5:fx),(ih-sh)*(fy==null?.5:fy),sw,sh,x,y,w,h)}
  else{c.fillStyle=lg(c,0,y,0,y+h,[0,'#7fb2d9',1,'#2c5d7a']);c.fillRect(x,y,w,h)}
 }
 var FONT='-apple-system,BlinkMacSystemFont,"SF Pro Text","Inter","Helvetica Neue",sans-serif';

 /* ---------- WORK and SPLIT: the screen is 3440 x 1440, so each half is 1720 x 1440 ---------- */
 function winChrome(c,x,y,w,h,title,dark){
  c.save();c.shadowColor='rgba(20,30,60,.28)';c.shadowBlur=26;c.shadowOffsetY=8;rr(c,x,y,w,h,10);c.fillStyle='#fff';c.fill();c.restore();
  c.save();rr(c,x,y,w,h,10);c.clip();c.fillStyle='#f3f3f5';c.fillRect(x,y,w,30);c.fillStyle='rgba(0,0,0,.08)';c.fillRect(x,y+30,w,1);
  ['#c9c9ce','#c9c9ce','#c9c9ce'].forEach(function(col,i){c.beginPath();c.arc(x+16+i*17,y+15,5.5,0,PI*2);c.fillStyle=col;c.fill()});
  c.fillStyle='#3a3a3c';c.font='600 12px '+FONT;c.textAlign='center';c.fillText(title,x+w/2,y+19);c.textAlign='left';c.restore();
 }
 function textLines(c,x,y,w,n,r,gap){for(var i=0;i<n;i++){var lw=(i%6===5)?w*(.3+r()*.3):w*(.82+r()*.18);c.fillRect(x,y+i*(gap||15),lw,6)}}
 function menu(c,x,w,app){c.fillStyle='rgba(255,255,255,.7)';c.fillRect(x,0,w,22);c.fillStyle='#1d1d1f';c.font='600 12px '+FONT;c.textAlign='left';c.fillText(app,x+16,15);c.font='12px '+FONT;['File','Edit','View','Insert','Format','Window'].forEach(function(s,i){c.fillText(s,x+96+i*56,15)});c.textAlign='right';c.fillText('Fri 9:41',x+w-16,15);c.textAlign='left'}
 function docW(c,x,Y,ww,WH,t){var r=rnd(3);winChrome(c,x,Y,ww,WH,'Q4 Proposal.docx');
  c.fillStyle='#1d1d1f';c.font='700 26px '+FONT;c.fillText('Q4 Proposal',x+56,Y+78);c.fillStyle='#636366';c.font='13px '+FONT;c.fillText('Draft 3 · shared with the team',x+56,Y+100);
  c.fillStyle='#c7c7cc';textLines(c,x+56,Y+124,ww-112,10,r);c.fillStyle='#1d1d1f';c.font='600 16px '+FONT;c.fillText('Timeline',x+56,Y+300);c.fillStyle='#c7c7cc';textLines(c,x+56,Y+316,ww-112,8,r);
  c.fillStyle='#1d1d1f';c.font='600 16px '+FONT;c.fillText('Budget',x+56,Y+468);c.fillStyle='#c7c7cc';textLines(c,x+56,Y+484,ww-112,M.max(0,M.floor((WH-484-34)/15)),r);
  if(M.floor(t*1.6)%2===0){c.fillStyle='#0071e3';c.fillRect(x+56+(ww-112)*.42,Y+421,2,16)}}
 function notesW(c,x,Y,ww,WH,t){var r=rnd(11);winChrome(c,x,Y,ww,WH,'Field Notes.pages');
  c.fillStyle='#1d1d1f';c.font='700 24px '+FONT;c.fillText('Coastline survey',x+48,Y+76);
  var ph=M.max(60,M.min(250,WH-190));c.save();rr(c,x+48,Y+94,ww-96,ph,8);c.clip();photo(c,x+48,Y+94,ww-96,ph,.5+.08*M.sin(t*.15),.55);c.restore();
  c.fillStyle='#636366';c.font='12px '+FONT;c.fillText('Fig. 1 — north headland, morning light',x+48,Y+94+ph+18);
  c.fillStyle='#c7c7cc';textLines(c,x+48,Y+94+ph+40,ww-96,M.max(0,M.floor((WH-(94+ph+40)-34)/15)),r)}
 function termW(c,x,Y,ww,WH,t){var r=rnd(21);winChrome(c,x,Y,ww,WH,'Terminal');
  c.save();rr(c,x,Y,ww,WH,10);c.clip();c.fillStyle='#16171c';c.fillRect(x,Y+31,ww,WH-31);
  var cols=['#7aa7ff','#33d6a6','#ffb070','#c792ea','#e4e4e4'],n=M.max(1,M.floor((WH-62)/20)),i,q;
  for(i=0;i<n;i++){var lx=x+22+(i%5===3?24:0),segs=2+M.floor(r()*3);for(q=0;q<segs;q++){var sw=30+r()*110;if(lx+sw>x+ww-22)break;c.fillStyle=cols[M.floor(r()*cols.length)];c.globalAlpha=.85;c.fillRect(lx,Y+52+i*20,sw,6);lx+=sw+12}}
  c.globalAlpha=1;if(M.floor(t*1.6)%2===0){c.fillStyle='#e4e4e4';c.fillRect(x+22,Y+52+n*20-2,10,14)}c.restore()}
 var VALS=[['Hardware',4820,5210,4995,5600],['Software',2310,2480,2650,2700],['Travel',980,1120,860,1300],['Shipping',1540,1610,1720,1810],['Services',3200,3350,3410,3600],['Training',640,700,760,820]],TOT=['Total',0,0,0,0];
 VALS.forEach(function(v){for(var q=1;q<5;q++)TOT[q]+=v[q]});
 function sheetW(c,x,Y,ww,WH,t){winChrome(c,x,Y,ww,WH,'Budget 2027.xlsx');
  var cw=M.floor((ww-34)/7),gx0=x+34,gy0=Y+56,rh=26,rows=8,i,j,k;
  c.fillStyle='#f5f5f7';c.fillRect(x,Y+31,ww,24);c.fillStyle='#6e6e73';c.font='600 11px '+FONT;c.textAlign='center';
  for(j=0;j<7;j++)c.fillText('ABCDEFG'[j],gx0+cw*j+cw/2,Y+47);
  var hi=M.floor(t*.8)%24,hr=hi%6,hc=1+(M.floor(hi/6)%4);
  for(i=0;i<rows;i++){var yy=gy0+i*rh;c.fillStyle='#6e6e73';c.font='11px '+FONT;c.textAlign='center';c.fillText(i+1,x+17,yy+17);
   if(i===0){c.font='600 12px '+FONT;c.fillStyle='#1d1d1f';c.textAlign='left';c.fillText('Category',gx0+8,yy+17);c.textAlign='right';['Q1','Q2','Q3','Q4','Total','Δ'].forEach(function(s,q){c.fillText(s,gx0+cw*(q+2)-10,yy+17)});continue}
   var row=i<7?VALS[i-1]:TOT;c.font=(i===7?'600 ':'')+'12px '+FONT;c.fillStyle='#1d1d1f';c.textAlign='left';c.fillText(row[0],gx0+8,yy+17);c.textAlign='right';
   for(k=1;k<5;k++)c.fillText('$'+row[k].toLocaleString('en-US'),gx0+cw*(k+1)-10,yy+17);
   c.fillText('$'+(row[1]+row[2]+row[3]+row[4]).toLocaleString('en-US'),gx0+cw*6-10,yy+17);
   var d=(row[4]-row[1])/row[1]*100;c.fillStyle=d>=0?'#146b2e':'#c4302b';c.fillText((d>=0?'+':'')+d.toFixed(1)+'%',gx0+cw*7-10,yy+17)}
  c.textAlign='left';c.strokeStyle='rgba(0,0,0,.08)';c.lineWidth=1;
  for(i=0;i<=rows;i++){c.beginPath();c.moveTo(x,gy0+i*rh+.5);c.lineTo(x+ww,gy0+i*rh+.5);c.stroke()}
  for(j=0;j<=7;j++){c.beginPath();c.moveTo(gx0+cw*j+.5,gy0);c.lineTo(gx0+cw*j+.5,gy0+rows*rh);c.stroke()}
  c.strokeStyle='#0071e3';c.lineWidth=2;c.strokeRect(gx0+cw*hc+1,gy0+(hr+1)*rh+1,cw-2,rh-2);
  var cx=x+40,cy=gy0+rows*rh+36,chW=ww-80,chH=WH-(cy-Y)-26,gw=chW/6,base=cy+chH;c.fillStyle='#1d1d1f';c.font='600 13px '+FONT;c.fillText('Spend by quarter',cx,cy);
  var cols4=['#0071e3','#33a1ff','#7c4dff','#00c7a0'];
  for(var q2=0;q2<4;q2++)for(k=0;k<6;k++){var bh=VALS[k][q2+1]/5600*(chH-34)*(.92+.08*M.sin(t*.8+k+q2));c.fillStyle=cols4[q2];rr(c,cx+k*gw+(gw-4*22)/2+q2*22,base-bh,18,bh,3);c.fill()}
  c.fillStyle='rgba(0,0,0,.1)';c.fillRect(cx,base,chW,1)}
 function work(c,W,H,t){
  DGRibbonsL340.draw(c,W,H,t+3); // wallpaper: the page's shared colour ribbons
  menu(c,0,W,'Deco Gear');
  var Y=38,WH=H-56,ww=(W-36-16)/2;docW(c,18,Y,ww,WH,t);sheetW(c,18+ww+16,Y,ww,WH,t);
 }
 function split(c,W,H,t){ // picture-by-picture: two computers, one on each 1720 x 1440 half
  var half=W/2,Y=38,WH=H-56,ww=half-32,nh=M.round(WH*.56);
  c.save();c.beginPath();c.rect(0,0,half,H);c.clip();DGRibbonsL340.draw(c,W,H,t+3);menu(c,0,half,'Deco Gear');docW(c,16,Y,ww,WH,t);c.restore();
  c.save();c.beginPath();c.rect(half,0,half,H);c.clip();DGRibbonsL340.draw(c,W,H,t+8.4);menu(c,half,half,'Laptop');notesW(c,half+16,Y,ww,nh,t);termW(c,half+16,Y+nh+14,ww,WH-nh-14,t);c.restore();
  c.fillStyle='#050506';c.fillRect(half-3,0,6,H);
  c.font='600 14px '+FONT;c.textAlign='center';
  [['PC',half/2],['Laptop',half*1.5]].forEach(function(L){var tw=c.measureText(L[0]).width+30;rr(c,L[1]-tw/2,H-52,tw,30,15);c.fillStyle='rgba(8,8,16,.74)';c.fill();c.fillStyle='#fff';c.fillText(L[0],L[1],H-32)});c.textAlign='left'
 }
 /* ---------- PLAY: a wide racing scene ---------- */
 function play(c,W,H,t){
  var hz=H*.5,vp=W/2,sp=t*1.1;
  c.fillStyle=lg(c,0,0,0,hz,[0,'#141a46',.45,'#5a2b6e',.8,'#e2566a',1,'#ffb36b']);c.fillRect(0,0,W,hz+2);
  var sg=c.createRadialGradient(vp,hz-30,0,vp,hz-30,520);sg.addColorStop(0,'rgba(255,214,140,.9)');sg.addColorStop(.12,'rgba(255,170,110,.55)');sg.addColorStop(1,'rgba(255,120,90,0)');c.fillStyle=sg;c.fillRect(0,0,W,hz+2);
  c.beginPath();c.arc(vp,hz-28,70,0,PI*2);c.fillStyle='#ffe2b0';c.fill();
  for(var s=0;s<70;s++){var r=rnd(s+5);c.fillStyle='rgba(255,255,255,'+(.25+r()*.5)*(1-r()*.4)+')';c.fillRect(r()*W,r()*hz*.42,1.4,1.4)}
  function ridge(base,amp,col,f,ph){c.beginPath();c.moveTo(0,hz+2);for(var x=0;x<=W;x+=12){var y=base-amp*(.55+.3*M.sin(x*f+ph)+.15*M.sin(x*f*3.1+ph*2))*(.6+.4*M.abs(x-vp)/vp);c.lineTo(x,y)}c.lineTo(W,hz+2);c.closePath();c.fillStyle=col;c.fill()}
  ridge(hz,110,'#6b3a6e',.004,1.3);ridge(hz,70,'#3f2350',.007,.4);ridge(hz+2,34,'#24152f',.013,2.2);
  c.fillStyle=lg(c,0,hz,0,H,[0,'#2a1830',1,'#08060b']);c.fillRect(0,hz,W,H-hz);
  // road
  var bw=W*.5;c.beginPath();c.moveTo(vp-6,hz);c.lineTo(vp+6,hz);c.lineTo(vp+bw,H);c.lineTo(vp-bw,H);c.closePath();c.fillStyle=lg(c,0,hz,0,H,[0,'#3a2c3e',1,'#141118']);c.fill();
  c.strokeStyle='rgba(255,230,210,.85)';c.lineWidth=3;c.beginPath();c.moveTo(vp-5,hz);c.lineTo(vp-bw*.94,H);c.moveTo(vp+5,hz);c.lineTo(vp+bw*.94,H);c.stroke();
  var N=14,fr=(sp*1.6)%1;
  for(var i=0;i<N;i++){var z0=(i+fr)/N,z1=(i+fr+.45)/N;if(z1>1)z1=1;var y0=hz+(H-hz)*z0*z0,y1=hz+(H-hz)*z1*z1,w0=2+bw*.018*z0*z0*4,w1=2+bw*.018*z1*z1*4;
   c.fillStyle='rgba(255,220,150,.9)';c.beginPath();c.moveTo(vp-w0/2,y0);c.lineTo(vp+w0/2,y0);c.lineTo(vp+w1/2,y1);c.lineTo(vp-w1/2,y1);c.closePath();c.fill()}
  // kerbs/posts
  for(i=0;i<10;i++){var z=(i+(sp*1.6)%1)/10,zz=z*z,y=hz+(H-hz)*zz,off=6+bw*1.08*zz,ph=y-hz,hgt=4+ph*.55;
   [-1,1].forEach(function(sd){var px=vp+sd*off;c.fillStyle=i%2?'#f2f2f2':'#e2334a';c.fillRect(px-1-zz*6,y-hgt,2+zz*12,hgt);c.fillStyle='rgba(255,180,90,.9)';c.fillRect(px-1-zz*6,y-hgt,2+zz*12,2+zz*6)})}
  // car (rear view), drawn about its bottom centre so it can be scaled for the taller screen
  var cx=vp+M.sin(t*.7)*36,cy=H-48,cw=360,chh=120;c.save();c.translate(cx,cy);c.scale(1.28,1.28);c.translate(-cx,-cy);
  c.fillStyle='rgba(0,0,0,.55)';c.beginPath();c.ellipse(cx,cy+10,cw*.55,22,0,0,PI*2);c.fill();
  c.fillStyle='#16151b';rr(c,cx-cw/2-6,cy-54,46,64,10);c.fill();rr(c,cx+cw/2-40,cy-54,46,64,10);c.fill();
  c.beginPath();c.moveTo(cx-cw/2,cy-30);c.quadraticCurveTo(cx-cw/2+10,cy-chh+14,cx-cw*.28,cy-chh);c.lineTo(cx+cw*.28,cy-chh);c.quadraticCurveTo(cx+cw/2-10,cy-chh+14,cx+cw/2,cy-30);c.lineTo(cx+cw/2-4,cy);c.lineTo(cx-cw/2+4,cy);c.closePath();
  c.fillStyle=lg(c,0,cy-chh,0,cy,[0,'#2d6cdf',.55,'#1a3f9c',1,'#0b1a46']);c.fill();
  c.fillStyle=lg(c,0,cy-chh,0,cy-chh+44,[0,'#ffc9a0',1,'#3a2a4a']);c.beginPath();c.moveTo(cx-cw*.24,cy-chh+6);c.lineTo(cx+cw*.24,cy-chh+6);c.lineTo(cx+cw*.3,cy-chh+44);c.lineTo(cx-cw*.3,cy-chh+44);c.closePath();c.fill();
  c.fillStyle='#0d0d12';c.fillRect(cx-cw*.52,cy-chh-14,cw*1.04,12);c.fillRect(cx-cw*.4,cy-chh-4,8,12);c.fillRect(cx+cw*.4-8,cy-chh-4,8,12);
  c.save();c.shadowColor='#ff2a3a';c.shadowBlur=26;c.fillStyle='#ff3b4a';rr(c,cx-cw*.44,cy-62,cw*.24,12,6);c.fill();rr(c,cx+cw*.2,cy-62,cw*.24,12,6);c.fill();c.restore();
  c.fillStyle='#0b0b10';rr(c,cx-60,cy-40,120,22,6);c.fill();c.fillStyle='#e8e8ee';c.font='700 14px '+FONT;c.textAlign='center';c.fillText('DG 34',cx,cy-24);c.restore();
  // HUD
  c.textAlign='left';c.fillStyle='rgba(255,255,255,.92)';c.font='italic 800 30px '+FONT;c.fillText('LAP 2/3',40,52);c.font='600 16px '+FONT;c.fillStyle='rgba(255,255,255,.7)';c.fillText('POS 3 / 12',42,78);
  c.fillText('1:12.'+(String(M.floor((t*37)%100)).padStart(2,'0')),42,100);
  c.textAlign='right';c.fillStyle='#fff';c.font='italic 800 64px '+FONT;c.fillText(String(204+M.round(8*M.sin(t*.9))),W-110,H-36);c.font='italic 700 18px '+FONT;c.fillStyle='rgba(255,255,255,.75)';c.fillText('km/h',W-48,H-38);
  c.strokeStyle='rgba(255,255,255,.5)';c.lineWidth=3;c.beginPath();c.arc(W-150,H-60,96,PI*.85,PI*2.15);c.stroke();c.strokeStyle='#ff6a3d';c.lineWidth=5;c.beginPath();c.arc(W-150,H-60,96,PI*.85,PI*(.85+1.3*(.72+.05*M.sin(t*.9))));c.stroke();
  // minimap
  c.save();c.translate(W-130,70);c.strokeStyle='rgba(255,255,255,.75)';c.lineWidth=4;c.beginPath();c.ellipse(0,0,80,40,0,0,PI*2);c.stroke();var a=t*.6;c.fillStyle='#ff3b4a';c.beginPath();c.arc(M.cos(a)*80,M.sin(a)*40,6,0,PI*2);c.fill();c.restore();c.textAlign='left';
 }

 var SCENES={work:work,split:split,play:play};

 /* ---------- cards ---------- */
 var maps=null,cards=[];
 fetch(DGWI.maps).then(function(r){return r.json()}).then(function(j){maps={};['front','front-34'].forEach(function(k){maps[k]=prepMap(j[k])});cards.forEach(draw)}).catch(function(){});
 root.querySelectorAll('.vrs-item').forEach(function(li){
  var mon=li.querySelector('.vrs-mon'),cv=mon.querySelector('canvas'),scr=document.createElement('canvas');scr.width=1920;scr.height=804;
  var C={li:li,mon:mon,cv:cv,ctx:cv.getContext('2d'),scr:scr,sx:scr.getContext('2d'),slug:mon.getAttribute('data-img'),paint:SCENES[li.getAttribute('data-scene')],img:new Image(),vis:false,t0:performance.now()};
  C.img.decoding='async';C.img.onload=function(){draw(C)};cards.push(C);
 });
 function size(C){var d=M.min(devicePixelRatio||1,2);C.cv.width=M.round(C.mon.clientWidth*d);C.cv.height=M.round(C.mon.clientHeight*d)}
 function draw(C,now){
  if(!maps||!C.img.naturalWidth)return;if(!C.cv.width||C.cv.width<4)size(C);
  var t=RM?3:((now||performance.now())-C.t0)/1000+2;
  C.paint(C.sx,1920,804,t);
  C.ctx.clearRect(0,0,C.cv.width,C.cv.height);C.ctx.drawImage(C.img,0,0,C.cv.width,C.cv.height);
  mapPaint(C.ctx,maps[C.slug],{x:0,y:0,w:C.cv.width,h:C.cv.height},C.scr);
 }
 var raf=0,last=0;
 function loop(now){raf=0;var any=false;if(now-last>=33){last=now;cards.forEach(function(C){if(C.vis){draw(C,now);any=true}})}else any=cards.some(function(C){return C.vis});if(any)raf=requestAnimationFrame(loop)}
 var vio=new IntersectionObserver(function(es){es.forEach(function(e){var C=cards.filter(function(k){return k.mon===e.target})[0];if(!C)return;C.vis=e.isIntersecting&&e.intersectionRatio>0;
  if(C.vis&&!C.img.src){var w=C.mon.clientWidth*M.min(devicePixelRatio||1,2);C.img.src=DGWI.src(C.slug,w)}
  if(C.vis){size(C);draw(C)}if(!RM&&C.vis&&!raf)raf=requestAnimationFrame(loop)})},{rootMargin:'300px 300px',threshold:[0,.01]});
 cards.forEach(function(C){vio.observe(C.mon)});
 coast.onload=function(){cards.forEach(function(C){draw(C)})};
 var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){cards.forEach(function(C){size(C);draw(C)})},150)});

 /* ---------- gallery controls ---------- */
 var gal=root.querySelector('[data-vrs-track]'),items=[].slice.call(root.querySelectorAll('.vrs-item')),dots=[].slice.call(root.querySelectorAll('.vrs-dots button')),prev=root.querySelector('[data-vrs-prev]'),next=root.querySelector('[data-vrs-next]'),cur=0;
 function gut(){return parseFloat(getComputedStyle(gal.firstElementChild).paddingLeft)||0}
 function go(i){i=M.max(0,M.min(items.length-1,i));var L=items[i].offsetLeft-gut();gal.scrollTo({left:L,behavior:RM?'auto':'smooth'})}
 function sync(){var g=gut(),best=0,bd=1e9;items.forEach(function(it,i){var d=M.abs(it.offsetLeft-g-gal.scrollLeft);if(d<bd){bd=d;best=i}});
  if(gal.scrollLeft+gal.clientWidth>=gal.scrollWidth-4)best=items.length-1;cur=best;
  dots.forEach(function(d,i){d.setAttribute('aria-selected',i===cur?'true':'false')});prev.disabled=gal.scrollLeft<4;next.disabled=gal.scrollLeft+gal.clientWidth>=gal.scrollWidth-4}
 prev.addEventListener('click',function(){go(cur-1)});next.addEventListener('click',function(){go(cur+1)});
 dots.forEach(function(d,i){d.addEventListener('click',function(){go(i)})});
 gal.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(cur+1)}else if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1)}});
 var st;gal.addEventListener('scroll',function(){cancelAnimationFrame(st);st=requestAnimationFrame(sync)},{passive:true});
 sync();
 window.DG_VERSATILITY={go:go};
})();

(function(){
  var root=document.getElementById('dg-connect'); if(!root) return;
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function count(el){
    var to=+el.dataset.to; if(RM){el.textContent=to;return;}
    var t0=performance.now(),D=1800;
    (function f(t){var p=Math.min(1,(t-t0)/D);p=1-Math.pow(1-p,3);el.textContent=Math.round(to*p);if(p<1)requestAnimationFrame(f);})(t0);
  }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return; var el=e.target; el.classList.add('in'); io.unobserve(el);
      if(el.classList.contains('cn-dark')){var n=el.querySelector('.n'); if(n) count(n);}
    });
  },{rootMargin:'0px 0px -12% 0px',threshold:.15});
  [].forEach.call(root.querySelectorAll('.dgx-reveal'),function(el){io.observe(el);});
  window.DG_CONNECT={};
})();

(function(){
  var root=document.getElementById('dg-performance'); if(!root) return;
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var M=Math, cv=root.querySelector('.pf-cv'), c=cv.getContext('2d');
  var UI='-apple-system,BlinkMacSystemFont,"SF Pro Text","Inter","Helvetica Neue",sans-serif', DISP='-apple-system,BlinkMacSystemFont,"SF Pro Display","Inter","Helvetica Neue",sans-serif';
  /* the two coverage figures from the specifications: 100% sRGB and 85% NTSC (no DCI-P3 figure exists for this monitor). Nothing here is measured or simulated: each ring is filled to the listed percentage. */
  var G=[{n:'sRGB',v:100,a:'#ff4081',b:'#ff9500'},{n:'NTSC',v:85,a:'#00e6a0',b:'#00c7ff'}];
  var W=0,H=0,dpr=1,t0=0,raf=0,p=RM?[1,1]:[0,0],started=false;
  function size(){
    var r=cv.getBoundingClientRect(); dpr=M.min(2,window.devicePixelRatio||1);
    W=M.round(r.width); H=M.round(r.height); cv.width=W*dpr; cv.height=H*dpr; c.setTransform(dpr,0,0,dpr,0,0); draw();
  }
  function draw(){
    if(!W) return; c.clearRect(0,0,W,H);
    var mob=W<600, slot=W/G.length, D=M.min(slot*.74,mob?112:216,H*.62), R=D/2, lw=D*.085, cy=H*(mob?.44:.46);
    var bg=c.createRadialGradient(W*.5,H*1.15,0,W*.5,H*1.15,W*.7); bg.addColorStop(0,'rgba(47,108,181,.22)'); bg.addColorStop(1,'rgba(0,0,0,0)'); c.fillStyle=bg; c.fillRect(0,0,W,H);
    G.forEach(function(g,i){
      var cx=slot*(i+.5), q=p[i], arc=g.v/100*q*M.PI*2, r0=R-lw/2;
      c.lineCap='round'; c.lineWidth=lw; c.strokeStyle='rgba(255,255,255,.12)'; c.beginPath(); c.arc(cx,cy,r0,0,M.PI*2); c.stroke();
      if(arc>.001){
        var gr=c.createLinearGradient(cx-R,cy-R,cx+R,cy+R); gr.addColorStop(0,g.a); gr.addColorStop(1,g.b);
        c.save(); c.strokeStyle=gr; c.shadowColor=g.a; c.shadowBlur=D*.09; c.beginPath(); c.arc(cx,cy,r0,-M.PI/2,-M.PI/2+arc); c.stroke(); c.restore();
      }
      c.fillStyle='#f5f5f7'; c.textAlign='center'; c.textBaseline='middle'; c.font='600 '+M.round(D*.27)+'px '+DISP; c.fillText(g.v+'%',cx,cy+D*.01);
      c.font='500 '+(mob?14:20)+'px '+UI; c.fillStyle='#d2d2d7'; c.textBaseline='alphabetic'; c.fillText(g.n,cx,cy+R+(mob?26:38));
    });
  }
  function tick(now){
    raf=0; if(!t0) t0=now; var done=true;
    for(var i=0;i<G.length;i++){var k=M.min(1,M.max(0,(now-t0)/1000-.15*i)/1.5); p[i]=1-M.pow(1-k,3); if(k<1) done=false}
    draw(); if(!done) raf=requestAnimationFrame(tick);
  }
  function start(){ if(started) return; started=true; if(RM){draw();return} raf=requestAnimationFrame(tick); }
  var inited=false;
  function init(){if(inited) return; inited=true; size(); window.addEventListener('resize',function(){size();},{passive:true});}
  new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ init(); } });
  },{rootMargin:'200px 0px'}).observe(cv);
  new IntersectionObserver(function(es,o){
    es.forEach(function(e){ if(e.isIntersecting){ init(); start(); o.disconnect(); } });
  },{threshold:.4}).observe(cv);
  // stats are never counted up: the final value is always in the DOM, so no capture or throttled tab
  // can show a half-way number. The card reveals with a fade/rise instead (.dgx-reveal in base CSS).
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){if(!e.isIntersecting) return; var el=e.target; el.classList.add('in'); io.unobserve(el);});
  },{rootMargin:'0px 0px -12% 0px',threshold:.15});
  [].forEach.call(root.querySelectorAll('.dgx-reveal'),function(el){io.observe(el);});
  window.DG_PERFORMANCE={draw:draw,rings:function(q){p=[q,q];draw()}};
})();

(function(){
  var root=document.getElementById('dg-desk'); if(!root) return;
  /* width only: the monitor is 31.9 in wide (data/facts/DGVIEW304.md, with or without the stand). The planner draws the curved panel from above, never a stand
     footprint, and the desk has a fixed depth that is not a control and not a number on the page. */
  var MON_W=31.9, MAXW=96, MIN_W=24, DESK_D=28, CM=2.54;
  var st={w:60,u:'in'};
  try{var sv=JSON.parse(localStorage.getItem('dg-desk')||'null'); if(sv&&sv.w) st={w:+sv.w,u:sv.u==='cm'?'cm':'in'}; if(!(st.w>=MIN_W&&st.w<=MAXW)) st.w=60;}catch(e){}
  var plan=root.querySelector('.dk-plan'), rw=root.querySelector('.dk-rw'), nw=root.querySelector('.dk-nw'),
      status=root.querySelector('.dk-status'), units=[].slice.call(root.querySelectorAll('.dk-u'));
  function fmt(inches,dec){ if(st.u==='cm'){return Math.round(inches*CM)+' cm';} var v=Math.round(inches*(dec?10:1))/(dec?10:1); return v+' in'; }
  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  function layout(){
    var W=plan.clientWidth; if(!W) return;
    var s=W<600?W/(Math.max(st.w,MON_W)+9):W/(MAXW+8);
    plan.style.setProperty('--s',s+'px');
    var dw=st.w*s, dd=DESK_D*s;
    plan.style.setProperty('--dw',dw+'px'); plan.style.setProperty('--dd',dd+'px'); plan.style.setProperty('--mw',(MON_W*s)+'px');
    plan.style.setProperty('--gw',Math.max(0,(st.w-MON_W)/2*s)+'px');
    plan.style.setProperty('--ph',(12+dd+s*11+30)+'px');
  }
  function paint(){
    var spare=(st.w-MON_W)/2;
    root.classList.toggle('over',spare<0); root.classList.toggle('tight',spare>=0&&spare<3);
    root.querySelector('.dk-mw-t').textContent=fmt(MON_W,1);
    root.querySelector('.dk-dw-t').textContent=fmt(st.w);
    [].forEach.call(root.querySelectorAll('.dk-gap b'),function(b){b.textContent=fmt(spare,1);});
    var head,sub;
    if(spare<0){head='The screen is wider than this desk.'; sub='It reaches '+fmt(-spare,1)+' past each side. Try a wider desk, or put it on an arm with the VESA mount.';}
    else if(spare<3){head='It fits, with '+fmt(spare,1)+' to spare each side.'; sub='Snug. Measure twice.';}
    else {head='It fits, with '+fmt(spare,1)+' to spare each side.'; sub='Your desk is '+fmt(st.w)+' wide and the monitor takes '+fmt(MON_W,1)+'.';}
    status.innerHTML=head+'<small>'+sub+'</small>';
    var k=st.u==='cm'?CM:1;
    rw.min=nw.min=Math.round(MIN_W*k); rw.max=nw.max=Math.round(MAXW*k);
    rw.value=Math.round(st.w*k); if(document.activeElement!==nw) nw.value=Math.round(st.w*k);
    rw.style.setProperty('--p',((st.w-MIN_W)/(MAXW-MIN_W)*100)+'%');
    [].forEach.call(root.querySelectorAll('.dk-unit'),function(u){u.textContent=st.u;});
    units.forEach(function(b){var on=b.dataset.u===st.u;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');});
    layout();
    try{localStorage.setItem('dg-desk',JSON.stringify({w:st.w,d:30,u:st.u}));}catch(e){}
  }
  function fromUI(v){return st.u==='cm'?v/CM:v;}
  rw.addEventListener('input',function(){st.w=clamp(fromUI(+rw.value),MIN_W,MAXW);paint();});
  nw.addEventListener('input',function(){var v=parseFloat(nw.value); if(!isFinite(v)) return; v=fromUI(v); if(v>=MIN_W&&v<=MAXW){st.w=v;paint();}});
  nw.addEventListener('change',function(){var v=parseFloat(nw.value); st.w=isFinite(v)?clamp(fromUI(v),MIN_W,MAXW):st.w; nw.value=Math.round(st.w*(st.u==='cm'?CM:1)); paint();});
  units.forEach(function(b){b.addEventListener('click',function(){st.u=b.dataset.u;nw.blur();paint();});});
  var inited=false;
  function init(){if(inited) return; inited=true; paint(); window.addEventListener('resize',layout,{passive:true});}
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){if(!e.isIntersecting) return; var el=e.target; el.classList.add('in'); io.unobserve(el); init();});
  },{rootMargin:'0px 0px -10% 0px',threshold:.12});
  [].forEach.call(root.querySelectorAll('.dgx-reveal'),function(el){io.observe(el);});
  new IntersectionObserver(function(es,o){if(es[0].isIntersecting){init();o.disconnect();}},{rootMargin:'600px 0px'}).observe(root);
  window.DG_DESK={set:function(w){st.w=clamp(w,MIN_W,MAXW); paint();}};
})();

(function(){
  var root=document.getElementById('dg-accessories');if(!root)return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rail=root.querySelector('.acc-rail'),prev=root.querySelector('.acc-prev'),next=root.querySelector('.acc-next'),toast=root.querySelector('.acc-toast');
  root.querySelectorAll('.acc-card').forEach(function(c,i){c.style.setProperty('--i',i%4)});
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
  root.querySelectorAll('.dgx-reveal').forEach(function(n){io.observe(n)});
  function step(){var c=rail.querySelector('.acc-card');return c?c.getBoundingClientRect().width+20:400}
  function upd(){var m=rail.scrollWidth-rail.clientWidth;prev.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft>m-4}
  prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:reduce?'auto':'smooth'})});
  next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:reduce?'auto':'smooth'})});
  rail.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();
  var t;
  root.addEventListener('click',function(e){
    var b=e.target.closest('.acc-add');if(!b)return;
    var card=b.closest('.acc-card'),name=card.querySelector('.acc-name').textContent;
    var on=!b.classList.contains('done');b.classList.toggle('done',on);b.textContent=on?'Added':'Add';
    window.DG_ACCESSORIES.added[card.dataset.handle]=on;
    document.dispatchEvent(new CustomEvent('dg:accessory',{detail:{handle:card.dataset.handle,added:on}}));
    toast.textContent=on?'Added: '+name:'Removed: '+name;toast.classList.add('on');clearTimeout(t);t=setTimeout(function(){toast.classList.remove('on')},2200);
  });
  window.DG_ACCESSORIES={added:{}};
})();

(function(){
  var root=document.getElementById('dg-compare');if(!root)return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -6% 0px'});
  root.querySelectorAll('.dgx-reveal,.cmp-row').forEach(function(n){io.observe(n)});
  var grid=root.querySelector('.cmp-grid'),btns=root.querySelectorAll('.cmp-pick button');
  function pick(n){grid.dataset.pick=n;btns.forEach(function(b){b.setAttribute('aria-pressed',b.dataset.pick===String(n))});window.DG_COMPARE.pick=+n}
  btns.forEach(function(b){b.addEventListener('click',function(){pick(b.dataset.pick)})});
  window.DG_COMPARE={pick:1,set:pick};
})();
/* live screens: the three compare pictures power on with the page's colour ribbons, warped onto each picture's screen map. The maps are in
   dgr-dglux340-screen-maps.json: "front" (the live 34" render, the same body as this monitor and the 34" Business) and "cmp-40" (the 40" 5K2K render, live under an -l340 name). */
(function(){
  var root=document.getElementById('dg-compare');if(!root)return;
  var boxes=[].slice.call(root.querySelectorAll('[data-live]'));if(!boxes.length)return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FW=645,FH=270,fld=document.createElement('canvas');fld.width=FW;fld.height=FH;var fx=fld.getContext('2d');
  var logo=new Image();logo.src=(window.DGX&&DGX["dgx-duo-logo-allwhite.svg"])||'dgx-duo-logo-allwhite.svg';
  function field(t){DGRibbonsL340.draw(fx,FW,FH,t,{logo:logo,logoAt:-1})}
  var MAPS=null,live=[];
  function setup(box,map){
    var img=box.querySelector('img');
    function go(){
      var W=img.naturalWidth,H=img.naturalHeight,cv=document.createElement('canvas');cv.width=W;cv.height=H;cv.setAttribute('aria-hidden','true');
      box.appendChild(cv);var x=cv.getContext('2d');
      var cols=map.cols,x0=map.x0,x1=map.x1;
      live.push({draw:function(){x.clearRect(0,0,W,H);x.drawImage(img,0,0,W,H);
        for(var i=0;i<cols.length-1;i++){var a=cols[i],b=cols[i+1];
          var sx=(a.x-x0)/(x1-x0)*FW,sw=Math.max(.5,(b.x-a.x)/(x1-x0)*FW);
          var dx=a.x*W,dw=(b.x-a.x)*W+.6,dy=a.top*H,dh=(a.bottom-a.top)*H;
          x.drawImage(fld,sx,0,sw,FH,dx,dy,dw,dh)}
      },box:box});
      tick(performance.now());box.classList.add('on');
    }
    if(img.complete&&img.naturalWidth)go();else img.addEventListener('load',go,{once:true});
  }
  var t0=performance.now(),raf=0,vis=false;
  function tick(now){field(reduce?2:(now-t0)/1000+1);live.forEach(function(l){l.draw()});if(vis&&!reduce)raf=requestAnimationFrame(tick)}
  var started=false;
  function begin(){if(started||!MAPS||!vis)return;started=true;boxes.forEach(function(b){var m=MAPS[b.dataset.live];if(m)setup(b,m)});cancelAnimationFrame(raf);if(!reduce)raf=requestAnimationFrame(tick)}
  fetch(DGWI.maps).then(function(r){return r.json()}).then(function(j){MAPS=j;begin()}).catch(function(){});
  var io=new IntersectionObserver(function(es){vis=es[0].isIntersecting;
    begin();
    cancelAnimationFrame(raf);if(vis&&!reduce&&started)raf=requestAnimationFrame(tick)},{rootMargin:'100px 0px'});
  io.observe(root.querySelector('.cmp-top'));
  logo.onload=function(){if(started)tick(performance.now())};
})();

(function(){
  var root=document.getElementById('dg-reviews');if(!root)return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var num=root.querySelector('[data-count]');
  function count(){if(reduce||!num)return;var to=+num.dataset.count,t0=performance.now(),d=1200;
    (function f(t){var k=Math.min(1,(t-t0)/d),e=1-Math.pow(1-k,3);num.textContent=(to*e).toFixed(1);if(k<1)requestAnimationFrame(f)})(t0)}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');if(e.target.classList.contains('rev-score'))count();io.unobserve(e.target)}})},{rootMargin:'0px 0px -10% 0px'});
  root.querySelectorAll('.dgx-reveal').forEach(function(n){io.observe(n)});
  /* Bazaarvoice facade hook: the theme injects bv.js on this event; the mock only records it */
  root.addEventListener('click',function(e){var a=e.target.closest('[data-rev-open]');if(!a)return;
    document.dispatchEvent(new CustomEvent('dg:reviews-open',{detail:{write:a.getAttribute('data-rev-open')==='write'}}));window.DG_REVIEWS.opened++});
  window.DG_REVIEWS={opened:0};
})();

(function(){
  var root=document.getElementById('dg-why');if(!root)return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rail=root.querySelector('.why-rail'),prev=root.querySelector('.why-prev'),next=root.querySelector('.why-next');
  root.querySelectorAll('.why-tile').forEach(function(c,i){c.style.setProperty('--i',i)});
  var started=false;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);if(!started){started=true;delivery()}}})},{rootMargin:'0px 0px -8% 0px'});
  root.querySelectorAll('.dgx-reveal').forEach(function(n){io.observe(n)});
  function delivery(){
    var el=root.querySelector('[data-why-del]');
    function put(r){if(r&&r.deliveryShort){el.textContent=(r.shipsToday&&r.orderWithin?'Order within '+r.orderWithin+', ':'Order today, ')+'arrives '+r.deliveryShort+'.';window.DG_WHY.delivery=r.deliveryShort}}
    try{if(window.DGDelivery&&DGDelivery.init)DGDelivery.init(put)}catch(e){}
  }
  function step(){var c=rail.querySelector('.why-tile');return c?c.getBoundingClientRect().width+20:380}
  function upd(){var m=rail.scrollWidth-rail.clientWidth;prev.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft>m-4;root.querySelector('.why-ctl').style.visibility=m<8?'hidden':''}
  prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:reduce?'auto':'smooth'})});
  next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:reduce?'auto':'smooth'})});
  rail.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();
  root.addEventListener('click',function(e){var b=e.target.closest('.why-plus');if(!b)return;var t=b.closest('.why-tile'),o=!t.classList.contains('open');t.classList.toggle('open',o);b.setAttribute('aria-expanded',o)});
  window.DG_WHY={delivery:null};
})();

/* faq: Apple-style accordion with smooth height animation, Expand all, reveal-on-view, live delivery line */
(function(){
  var sec=document.getElementById('dg-faq');
  if(!sec)return;
  sec.classList.add('js'); // collapse trays (without JS every answer stays visible)
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items=[].slice.call(sec.querySelectorAll('.faq-item'));
  var all=sec.querySelector('.faq-all'),allT=sec.querySelector('.faq-all-t');
  var ready=false;

  function parts(it){return {btn:it.querySelector('.faq-btn'),tray:it.querySelector('.faq-tray'),a:it.querySelector('.faq-a')};}
  function eta(it){
    var el=it.querySelector('[data-faq-eta]');
    if(!el||!window.DGDelivery)return;
    var z=null;try{z=sessionStorage.getItem(DGDelivery.KEY||'dg_zip3');}catch(e){}
    var r;try{r=DGDelivery.estimate(Date.now(),z||'088');}catch(e){return;}
    if(!r||!r.deliveryShort)return;
    el.innerHTML=r.shipsToday
      ?'<span>Order within '+r.orderWithin+' and it’s estimated to arrive <b>'+r.deliveryShort+'</b>.</span>'
      :'<span>'+r.shipLabel.replace(/^Ships T/,'Ships t')+' · estimated to arrive <b>'+r.deliveryShort+'</b>.</span>';
    el.hidden=false;
  }
  function set(it,open,instant){
    var p=parts(it),isOpen=it.classList.contains('open');
    if(open===isOpen)return;
    var tr=p.tray;
    if(open){
      eta(it);
      it.classList.add('open');p.btn.setAttribute('aria-expanded','true');
      if(RM||instant){tr.style.height='auto';return;}
      tr.style.height=p.a.offsetHeight+'px';
    }else{
      if(!RM&&!instant){tr.style.height=tr.scrollHeight+'px';void tr.offsetHeight;}
      it.classList.remove('open');p.btn.setAttribute('aria-expanded','false');
      tr.style.height='0px';
    }
  }
  function sync(){
    var anyClosed=items.some(function(i){return !i.classList.contains('open');});
    allT.textContent=anyClosed?'Expand all':'Collapse all';
    all.setAttribute('aria-expanded',anyClosed?'false':'true');
  }
  function init(){
    if(ready)return;ready=true;
    // keep Apple's white / grey alternation whatever the section above uses
    var prev=sec.previousElementSibling;
    while(prev&&prev.tagName!=='SECTION')prev=prev.previousElementSibling;
    if(prev&&getComputedStyle(prev).backgroundColor===getComputedStyle(sec).backgroundColor)sec.classList.add('flip');
    items.forEach(function(it){
      var p=parts(it);
      p.tray.addEventListener('transitionend',function(e){
        if(e.target===p.tray&&e.propertyName==='height'&&it.classList.contains('open'))p.tray.style.height='auto';
      });
      p.btn.addEventListener('click',function(){set(it,!it.classList.contains('open'));sync();});
    });
    all.addEventListener('click',function(){
      var openAll=items.some(function(i){return !i.classList.contains('open');});
      items.forEach(function(it){set(it,openAll);});sync();
    });
    openFromHash();
  }
  function openFromHash(){
    var h=location.hash.slice(1);if(!h)return;
    var it=document.getElementById(h);
    if(it&&it.classList.contains('faq-item')){set(it,true,true);sync();}
  }
  window.addEventListener('hashchange',function(){init();openFromHash();});

  // reveal: stagger whatever enters together
  var revs=[].slice.call(sec.querySelectorAll('.dgx-reveal'));
  function showAll(){revs.forEach(function(r){r.classList.add('in');});}
  if(RM||!('IntersectionObserver' in window)){showAll();init();}
  else{
    var near=new IntersectionObserver(function(es){
      if(es.some(function(e){return e.isIntersecting;})){init();near.disconnect();}
    },{rootMargin:'1200px 0px'});
    near.observe(sec);
    var io=new IntersectionObserver(function(es){
      var n=0;
      es.forEach(function(e){
        if(!e.isIntersecting)return;
        e.target.style.transitionDelay=Math.min(n++,6)*70+'ms';
        e.target.classList.add('in');io.unobserve(e.target);
      });
    },{rootMargin:'0px 0px -8% 0px'});
    revs.forEach(function(r){io.observe(r);});
  }
  if(location.hash&&document.getElementById(location.hash.slice(1))&&sec.contains(document.getElementById(location.hash.slice(1)))){init();showAll();}

  window.DG_FAQ={open:function(id){init();var it=document.getElementById('faq-'+id);if(it){set(it,true);sync();}},
    close:function(id){var it=document.getElementById('faq-'+id);if(it){set(it,false);sync();}}};
})();

/* footer: on phones the link columns collapse into tap-to-open rows (desktop keeps them open, Apple-style) */
(function(){
  var cols=document.querySelectorAll('#dg-footer .ft-col');if(!cols.length)return;
  var mq=matchMedia('(max-width:733px)');
  function set(){cols.forEach(function(d){d.open=!mq.matches})}
  set();(mq.addEventListener?mq.addEventListener('change',set):mq.addListener(set));
})();
